var _map = (function(_map) {

  var data = {
    countries: [
  {
    "name": "Afghanistan",
    "code": "AF",
    "phoneCode": "+93",
    "currency": {
      "code": "AFN",
      "symbol": "؋"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Åland Islands",
    "code": "AX",
    "phoneCode": "+358",
    "currency": {
      "code": "AXE",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Albania",
    "code": "AL",
    "phoneCode": "+355",
    "currency": {
      "code": "ALL",
      "symbol": "Lek"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Algeria",
    "code": "DZ",
    "phoneCode": "+213",
    "currency": {
      "code": "DZD",
      "symbol": "د.ج"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "American Samoa",
    "code": "AS",
    "phoneCode": "+1",
    "currency": {
      "code": "USD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Andorra",
    "code": "AD",
    "phoneCode": "+376",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Angola",
    "code": "AO",
    "phoneCode": "+244",
    "currency": {
      "code": "AOA",
      "symbol": "Kz"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Anguilla",
    "code": "AI",
    "phoneCode": "+1",
    "currency": {
      "code": "XCD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Antarctica",
    "code": "AQ",
    "phoneCode": "+1",
    "currency": {
      "code": "XCD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Antigua and Barbuda",
    "code": "AG",
    "phoneCode": "+1",
    "currency": {
      "code": "XCD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Argentina",
    "code": "AR",
    "phoneCode": "+54",
    "currency": {
      "code": "ARS",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Armenia",
    "code": "AM",
    "phoneCode": "+374",
    "currency": {
      "code": "AMD",
      "symbol": "դր."
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Aruba",
    "code": "AW",
    "phoneCode": "+297",
    "currency": {
      "code": "AWG",
      "symbol": "Afl."
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Australia",
    "code": "AU",
    "phoneCode": "+61",
    "currency": {
      "code": "AUD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Austria",
    "code": "AT",
    "phoneCode": "+43",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Azerbaijan",
    "code": "AZ",
    "phoneCode": "+994",
    "currency": {
      "code": "AZN",
      "symbol": "ман."
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Bahamas",
    "code": "BS",
    "phoneCode": "+1",
    "currency": {
      "code": "BSD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Bahrain",
    "code": "BH",
    "phoneCode": "+973",
    "currency": {
      "code": "BHD",
      "symbol": ".د.ب"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Bangladesh",
    "code": "BD",
    "phoneCode": "+880",
    "currency": {
      "code": "BDT",
      "symbol": "৳"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Barbados",
    "code": "BB",
    "phoneCode": "+1",
    "currency": {
      "code": "BBD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Belarus",
    "code": "BY",
    "phoneCode": "+375",
    "currency": {
      "code": "BYR",
      "symbol": "Br"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Belgium",
    "code": "BE",
    "phoneCode": "+32",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Belize",
    "code": "BZ",
    "phoneCode": "+501",
    "currency": {
      "code": "BZD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Benin",
    "code": "BJ",
    "phoneCode": "+229",
    "currency": {
      "code": "XOF",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Bermuda",
    "code": "BM",
    "phoneCode": "+1",
    "currency": {
      "code": "BMD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Bhutan",
    "code": "BT",
    "phoneCode": "+975",
    "currency": {
      "code": "BTN",
      "symbol": "Nu."
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Bolivia",
    "code": "BO",
    "phoneCode": "+591",
    "currency": {
      "code": "BOB",
      "symbol": "Bs."
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Bosnia and Herzegovina",
    "code": "BA",
    "phoneCode": "+387",
    "currency": {
      "code": "BAM",
      "symbol": "KM"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Botswana",
    "code": "BW",
    "phoneCode": "+267",
    "currency": {
      "code": "BWP",
      "symbol": "P"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Bouvet Island",
    "code": "BV",
    "phoneCode": "+47",
    "currency": {
      "code": "NOK",
      "symbol": "kr"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Brazil",
    "code": "BR",
    "phoneCode": "+55",
    "languages": [
      {
        "code": "en_US",
        "short": "EN",
        "name": "English",
        "default": true
      },
      {
        "code": "pt_BR",
        "short": "PT",
        "name": "Portuguese",
        "default": false
      }
    ],
    "currency": {
      "code": "BRL",
      "symbol": "Ɽ"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "British Indian Ocean Territory",
    "code": "IO",
    "phoneCode": "+246",
    "currency": {
      "code": "USD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Brunei Darussalam",
    "code": "BN",
    "phoneCode": "+673",
    "currency": {
      "code": "BND",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Bulgaria",
    "code": "BG",
    "phoneCode": "+359",
    "currency": {
      "code": "BGN",
      "symbol": "лв"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Burkina Faso",
    "code": "BF",
    "phoneCode": "+226",
    "currency": {
      "code": "XOF",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Burundi",
    "code": "BI",
    "phoneCode": "+257",
    "currency": {
      "code": "BIF",
      "symbol": "FBu"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Cambodia",
    "code": "KH",
    "phoneCode": "+855",
    "currency": {
      "code": "KHR",
      "symbol": "៛"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Cameroon",
    "code": "CM",
    "phoneCode": "+237",
    "currency": {
      "code": "XAF",
      "symbol": "c"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Canada",
    "code": "CA",
    "phoneCode": "+1",
    "currency": {
      "code": "CAD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Cape Verde",
    "code": "CV",
    "phoneCode": "+238",
    "currency": {
      "code": "CVE",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Cayman Islands",
    "code": "KY",
    "phoneCode": "+1",
    "currency": {
      "code": "KYD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Central African Republic",
    "code": "CF",
    "phoneCode": "+236",
    "currency": {
      "code": "XAF",
      "symbol": "c"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Chad",
    "code": "TD",
    "phoneCode": "+235",
    "currency": {
      "code": "XAF",
      "symbol": "c"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Chile",
    "code": "CL",
    "phoneCode": "+56",
    "currency": {
      "code": "CLP",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "China",
    "languages": [
      {
        "code": "zh_CN",
        "short": "CN",
        "name": "Chinese (Simplified)",
        "default": false
      },
      {
        "code": "en_US",
        "short": "EN",
        "name": "English",
        "default": true
      }
    ],
    "code": "CN",
    "phoneCode": "+86",
    "currency": {
      "code": "CNY",
      "symbol": "¥"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y",
    "filters": [
      {
        "slug": "completed",
        "name": "完成"
      },
      {
        "slug": "past",
        "name": "过去"
      },
      {
        "slug": "readyToShip",
        "name": "准备出货"
      },
      {
        "slug": "inProgress",
        "name": "进行中"
      },
      {
        "slug": "assignedByMe",
        "name": "由我分配"
      },
      {
        "slug": "pendingMyApproval",
        "name": "我正在申请审批"
      },
      {
        "slug": "assignedToMe",
        "name": "分配给我"
      },
      {
        "slug": "pendingShipperApproval",
        "name": "待定托运人批准"
      },
      {
        "slug": "canceled",
        "name": "取消"
      },
      {
        "slug": "pendingMyAction",
        "name": "未决我的行动"
      },
      {
        "slug": "shipped",
        "name": "已运"
      },
      {
        "slug": "favorite",
        "name": "收藏夹"
      }
    ]
  },
  {
    "name": "Christmas Island",
    "code": "CX",
    "phoneCode": "+61",
    "currency": {
      "code": "AUD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Cocos (Keeling) Islands",
    "code": "CC",
    "phoneCode": "+61",
    "currency": {
      "code": "AUD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Colombia",
    "code": "CO",
    "phoneCode": "+57",
    "currency": {
      "code": "COP",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Comoros",
    "code": "KM",
    "phoneCode": "+269",
    "currency": {
      "code": "KMF",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Congo",
    "code": "CG",
    "phoneCode": "+242",
    "currency": {
      "code": "CDF",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Congo, The Democratic Republic of the",
    "code": "CD",
    "phoneCode": "+243",
    "currency": {
      "code": "CDF",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Cook Islands",
    "code": "CK",
    "phoneCode": "+682",
    "currency": {
      "code": "USD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Costa Rica",
    "code": "CR",
    "phoneCode": "+506",
    "currency": {
      "code": "CRC",
      "symbol": "₡"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Cote D'Ivoire",
    "code": "CI",
    "phoneCode": "+225",
    "currency": {
      "code": "CFA",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Croatia",
    "code": "HR",
    "phoneCode": "+385",
    "currency": {
      "code": "HRK",
      "symbol": "kn"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Cuba",
    "code": "CU",
    "phoneCode": "+53",
    "currency": {
      "code": "CUP",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Cyprus",
    "code": "CY",
    "phoneCode": "+357",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Czech Republic",
    "code": "CZ",
    "phoneCode": "+420",
    "currency": {
      "code": "CZK",
      "symbol": "Kč"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Denmark",
    "code": "DK",
    "phoneCode": "+45",
    "currency": {
      "code": "DKK",
      "symbol": "kr"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Djibouti",
    "code": "DJ",
    "phoneCode": "+253",
    "currency": {
      "code": "DJF",
      "symbol": "₣dj"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Dominica",
    "code": "DM",
    "phoneCode": "+1",
    "currency": {
      "code": "XCD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Dominican Republic",
    "code": "DO",
    "phoneCode": "+1",
    "currency": {
      "code": "DOP",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Ecuador",
    "code": "EC",
    "phoneCode": "+593",
    "currency": {
      "code": "USD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Egypt",
    "code": "EG",
    "phoneCode": "+20",
    "currency": {
      "code": "EGP",
      "symbol": "£"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "El Salvador",
    "code": "SV",
    "phoneCode": "+503",
    "currency": {
      "code": "USD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Equatorial Guinea",
    "code": "GQ",
    "phoneCode": "+240",
    "currency": {
      "code": "CFA",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Eritrea",
    "code": "ER",
    "phoneCode": "+291",
    "currency": {
      "code": "ERN",
      "symbol": "Nfk"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Estonia",
    "code": "EE",
    "phoneCode": "+372",
    "currency": {
      "code": "EEK",
      "symbol": "KR"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Ethiopia",
    "code": "ET",
    "phoneCode": "+251",
    "currency": {
      "code": "ETB",
      "symbol": "Br"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Falkland Islands (Malvinas)",
    "code": "FK",
    "phoneCode": "+500",
    "currency": {
      "code": "KFP",
      "symbol": "£"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Faroe Islands",
    "code": "FO",
    "phoneCode": "+298",
    "currency": {
      "code": "DKK",
      "symbol": "Kr"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Fiji",
    "code": "FJ",
    "phoneCode": "+679",
    "currency": {
      "code": "",
      "symbol": ""
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Finland",
    "code": "FI",
    "languages": [
      {
        "code": "en_US",
        "short": "EN",
        "name": "English (US)",
        "default": true
      },
      {
        "code": "sv_FI",
        "short": "FI",
        "name": "Finnish",
        "default": false
      }
    ],
    "phoneCode": "+358",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "France",
    "code": "FR",
    "phoneCode": "+33",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "French Guiana",
    "code": "GF",
    "phoneCode": "+594",
    "currency": {
      "code": "GNF",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "French Polynesia",
    "code": "PF",
    "phoneCode": "+689",
    "currency": {
      "code": "XPF",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "French Southern Territories",
    "code": "TF",
    "phoneCode": "+596",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Gabon",
    "code": "GA",
    "phoneCode": "+241",
    "currency": {
      "code": "",
      "symbol": ""
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Gambia",
    "code": "GM",
    "phoneCode": "+220",
    "currency": {
      "code": "GMD",
      "symbol": "D"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Georgia",
    "code": "GE",
    "phoneCode": "+995",
    "currency": {
      "code": "GEL",
      "symbol": "ლ"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Germany",
    "code": "DE",
    "phoneCode": "+49",
    "languages": [
      {
        "code": "en_US",
        "short": "EN",
        "name": "English (US)",
        "default": true
      },
      {
        "code": "de_DE",
        "short": "DE",
        "name": "German (DE)",
        "default": false
      }
    ],
    "additionalCustomsDocs": true,
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Ghana",
    "code": "GH",
    "phoneCode": "+233",
    "currency": {
      "code": "GHS",
      "symbol": "GH₵"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Gibraltar",
    "code": "GI",
    "phoneCode": "+350",
    "currency": {
      "code": "GIP",
      "symbol": "£"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Greece",
    "code": "GR",
    "phoneCode": "+30",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Greenland",
    "code": "GL",
    "phoneCode": "+299",
    "currency": {
      "code": "DKK",
      "symbol": "kr"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Grenada",
    "code": "GD",
    "phoneCode": "+1",
    "currency": {
      "code": "",
      "symbol": ""
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Guadeloupe",
    "code": "GP",
    "phoneCode": "+590",
    "currency": {
      "code": "XCD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Guam",
    "code": "GU",
    "phoneCode": "+1",
    "currency": {
      "code": "USD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Guatemala",
    "code": "GT",
    "phoneCode": "+502",
    "currency": {
      "code": "GTQ",
      "symbol": "Q"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Guernsey",
    "code": "GG",
    "phoneCode": "+44",
    "currency": {
      "code": "GBP",
      "symbol": "£"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Guinea",
    "code": "GN",
    "phoneCode": "+224",
    "currency": {
      "code": "GNF",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Guinea-Bissau",
    "code": "GW",
    "phoneCode": "+245",
    "currency": {
      "code": "CFA",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Guyana",
    "code": "GY",
    "phoneCode": "+592",
    "currency": {
      "code": "GYD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Haiti",
    "code": "HT",
    "phoneCode": "+509",
    "currency": {
      "code": "HTG",
      "symbol": "G"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Heard Island and Mcdonald Islands",
    "code": "HM",
    "phoneCode": "+61",
    "currency": {
      "code": "AUD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Holy See (Vatican City State)",
    "code": "VA",
    "phoneCode": "+39",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Honduras",
    "code": "HN",
    "phoneCode": "+504",
    "currency": {
      "code": "HNL",
      "symbol": "L"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Hong Kong",
    "code": "HK",
    "phoneCode": "+852",
    "currency": {
      "code": "HKD",
      "symbol": "£"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Hungary",
    "code": "HU",
    "phoneCode": "+36",
    "currency": {
      "code": "HUF",
      "symbol": "Ft"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Iceland",
    "code": "IS",
    "phoneCode": "+354",
    "currency": {
      "code": "ISK",
      "symbol": "kr"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "India",
    "code": "IN",
    "phoneCode": "+91",
    "languages": [
      {
        "code": "en_US",
        "short": "EN",
        "name": "English",
        "default": true
      }
    ],
    "originDestinationRequirements": true,
    "currency": {
      "code": "INR",
      "symbol": "Rupee"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Indonesia",
    "code": "ID",
    "phoneCode": "+62",
    "currency": {
      "code": "IDR",
      "symbol": "Rp"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Iran, Islamic Republic Of",
    "code": "IR",
    "OFAC": true,
    "phoneCode": "+98",
    "currency": {
      "code": "IRR",
      "symbol": "﷼"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Iraq",
    "code": "IQ",
    "phoneCode": "+964",
    "currency": {
      "code": "IQD",
      "symbol": "ع.د"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Ireland",
    "code": "IE",
    "phoneCode": "+353",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Isle of Man",
    "code": "IM",
    "phoneCode": "+44",
    "currency": {
      "code": "IMP",
      "symbol": "£"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Israel",
    "code": "IL",
    "languages": [
      {
        "code": "he_IL",
        "short": "HE",
        "name": "Hebrew",
        "direction": "rtl",
        "default": false
      },
      {
        "code": "en_US",
        "short": "EN",
        "name": "English",
        "default": true
      }
    ],
    "phoneCode": "+972",
    "currency": {
      "code": "ILS",
      "symbol": "₪"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Italy",
    "code": "IT",
    "phoneCode": "+39",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Jamaica",
    "code": "JM",
    "phoneCode": "+1",
    "currency": {
      "code": "JMD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Japan",
    "code": "JP",
    "phoneCode": "+81",
    "currency": {
      "code": "JPY",
      "symbol": "¥"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Jersey",
    "code": "JE",
    "phoneCode": "+44",
    "currency": {
      "code": "GBP",
      "symbol": "£"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Jordan",
    "code": "JO",
    "phoneCode": "+962",
    "currency": {
      "code": "JOD",
      "symbol": "د.ا"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Kazakhstan",
    "code": "KZ",
    "phoneCode": "+7",
    "currency": {
      "code": "KZT",
      "symbol": "₸"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Kenya",
    "code": "KE",
    "phoneCode": "+254",
    "currency": {
      "code": "KES",
      "symbol": "KSh"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Kiribati",
    "code": "KI",
    "phoneCode": "+686",
    "currency": {
      "code": "AUD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Korea, Democratic People's Republic of",
    "code": "KP",
    "phoneCode": "+850",
    "currency": {
      "code": "KPW",
      "symbol": "₩"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Korea, Republic of",
    "code": "KR",
    "phoneCode": "+82",
    "currency": {
      "code": "KRW",
      "symbol": "₩"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Kuwait",
    "code": "KW",
    "phoneCode": "+965",
    "currency": {
      "code": "KWD",
      "symbol": "د.ك"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Kyrgyzstan",
    "code": "KG",
    "phoneCode": "+996",
    "currency": {
      "code": "KGS",
      "symbol": "лв"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Lao People's Democratic Republic",
    "code": "LA",
    "phoneCode": "+856",
    "currency": {
      "code": "LAK",
      "symbol": "₭"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Latvia",
    "code": "LV",
    "phoneCode": "+371",
    "currency": {
      "code": "LVL",
      "symbol": "Ls"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Lebanon",
    "code": "LB",
    "phoneCode": "+961",
    "currency": {
      "code": "LBP",
      "symbol": "ل.ل"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Lesotho",
    "code": "LS",
    "phoneCode": "+266",
    "currency": {
      "code": "LSL",
      "symbol": "L"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Liberia",
    "code": "LR",
    "phoneCode": "+231",
    "currency": {
      "code": "LRD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Libyan Arab Jamahiriya",
    "code": "LY",
    "phoneCode": "+218",
    "currency": {
      "code": "LYD",
      "symbol": "ل.د"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Liechtenstein",
    "code": "LI",
    "phoneCode": "+423",
    "currency": {
      "code": "CHF",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Lithuania",
    "code": "LT",
    "phoneCode": "+370",
    "currency": {
      "code": "LTL",
      "symbol": "Lt"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Luxembourg",
    "code": "LU",
    "phoneCode": "+352",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Macao",
    "code": "MO",
    "phoneCode": "+853",
    "currency": {
      "code": "MOP",
      "symbol": "MOP$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Macedonia, The Former Yugoslav Republic of",
    "code": "MK",
    "phoneCode": "+389",
    "currency": {
      "code": "MKD",
      "symbol": "ден"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Madagascar",
    "code": "MG",
    "phoneCode": "+261",
    "currency": {
      "code": "MGA",
      "symbol": "Ar"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Malawi",
    "code": "MW",
    "phoneCode": "+265",
    "currency": {
      "code": "MWK",
      "symbol": "MK"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Malaysia",
    "code": "MY",
    "phoneCode": "+60",
    "currency": {
      "code": "MYR",
      "symbol": "RM"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Maldives",
    "code": "MV",
    "phoneCode": "+960",
    "currency": {
      "code": "MVR",
      "symbol": ".ރ"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Mali",
    "code": "ML",
    "phoneCode": "+223",
    "currency": {
      "code": "CFA",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Malta",
    "code": "MT",
    "phoneCode": "+356",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Marshall Islands",
    "code": "MH",
    "phoneCode": "+692",
    "currency": {
      "code": "USD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Martinique",
    "code": "MQ",
    "phoneCode": "+596",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Mauritania",
    "code": "MR",
    "phoneCode": "+222",
    "currency": {
      "code": "MRO",
      "symbol": "UM"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Mauritius",
    "code": "MU",
    "phoneCode": "+230",
    "currency": {
      "code": "MUR",
      "symbol": "Rs"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Mayotte",
    "code": "YT",
    "phoneCode": "+262",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Mexico",
    "code": "MX",
    "phoneCode": "+52",
    "languages": [
      {
        "code": "en_US",
        "short": "EN",
        "name": "English (US)",
        "default": true
      },
      {
        "code": "es_MX",
        "short": "ES",
        "name": "Spanish (MX)",
        "default": false
      }
    ],
    "currency": {
      "code": "MXN",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Micronesia, Federated States of",
    "code": "FM",
    "phoneCode": "+691",
    "currency": {
      "code": "USD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Moldova, Republic of",
    "code": "MD",
    "phoneCode": "+373",
    "currency": {
      "code": "MDL",
      "symbol": "L"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Monaco",
    "code": "MC",
    "phoneCode": "+377",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Mongolia",
    "code": "MN",
    "phoneCode": "+976",
    "currency": {
      "code": "MNT",
      "symbol": "₮"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Montserrat",
    "code": "MS",
    "phoneCode": "+1",
    "currency": {
      "code": "XCD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Morocco",
    "code": "MA",
    "phoneCode": "+212",
    "currency": {
      "code": "MAD",
      "symbol": "د.م"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Mozambique",
    "code": "MZ",
    "phoneCode": "+258",
    "currency": {
      "code": "MZN",
      "symbol": "MTn"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Myanmar",
    "code": "MM",
    "phoneCode": "+95",
    "currency": {
      "code": "MMK",
      "symbol": "K"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Namibia",
    "code": "NA",
    "phoneCode": "+264",
    "currency": {
      "code": "NAD",
      "symbol": "N$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Nauru",
    "code": "NR",
    "phoneCode": "+674",
    "currency": {
      "code": "AUD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Nepal",
    "code": "NP",
    "phoneCode": "+977",
    "currency": {
      "code": "NPR",
      "symbol": "Rs"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Netherlands",
    "code": "NL",
    "languages": [
      {
        "code": "nl_NL",
        "short": "NL",
        "name": "Dutch (NL)",
        "default": false
      },
      {
        "code": "en_US",
        "short": "EN",
        "name": "English (US)",
        "default": true
      }
    ],
    "phoneCode": "+31",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y",
    "filters": [
      {
        "slug": "completed",
        "name": "Voltooid"
      },
      {
        "slug": "past",
        "name": "Voorbij"
      },
      {
        "slug": "readyToShip",
        "name": "Klaar voor verzending"
      },
      {
        "slug": "inProgress",
        "name": "In behandeling"
      },
      {
        "slug": "assignedByMe",
        "name": "Toegewezen door me"
      },
      {
        "slug": "pendingMyApproval",
        "name": "In afwachting van mijn goedkeuring"
      },
      {
        "slug": "assignedToMe",
        "name": "Toegewezen aan mij"
      },
      {
        "slug": "pendingShipperApproval",
        "name": "In afwachting van goedkeuring verlader"
      },
      {
        "slug": "canceled",
        "name": "Geannuleerde"
      },
      {
        "slug": "pendingMyAction",
        "name": "In afwachting van mijn actie"
      },
      {
        "slug": "shipped",
        "name": "Verzonden"
      },
      {
        "slug": "favorite",
        "name": "Favoriet"
      }
    ]
  },
  {
    "name": "Netherlands Antilles",
    "code": "AN",
    "phoneCode": "+599",
    "currency": {
      "code": "NAF",
      "symbol": "ƒ"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "New Caledonia",
    "code": "NC",
    "phoneCode": "+687",
    "currency": {
      "code": "CFP",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "New Zealand",
    "code": "NZ",
    "phoneCode": "+64",
    "currency": {
      "code": "NZD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Nicaragua",
    "code": "NI",
    "phoneCode": "+505",
    "currency": {
      "code": "NIO",
      "symbol": "C$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Niger",
    "code": "NE",
    "phoneCode": "+227",
    "currency": {
      "code": "CFA",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Nigeria",
    "code": "NG",
    "phoneCode": "+234",
    "currency": {
      "code": "NGN",
      "symbol": "₦"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Niue",
    "code": "NU",
    "phoneCode": "+683",
    "currency": {
      "code": "NZD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Norfolk Island",
    "code": "NF",
    "phoneCode": "+672",
    "currency": {
      "code": "AUD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Northern Mariana Islands",
    "code": "MP",
    "phoneCode": "+1",
    "currency": {
      "code": "USD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Norway",
    "code": "NO",
    "languages": [
      {
        "code": "en_US",
        "short": "EN",
        "name": "English (US)",
        "default": true
      },
      {
        "code": "sv_FI",
        "short": "FI",
        "name": "Finnish",
        "default": false
      }
    ],
    "phoneCode": "+47",
    "currency": {
      "code": "NOK",
      "symbol": "Kr"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Oman",
    "code": "OM",
    "phoneCode": "+968",
    "currency": {
      "code": "OMR",
      "symbol": "ر.ع."
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Pakistan",
    "code": "PK",
    "phoneCode": "+92",
    "currency": {
      "code": "PKR",
      "symbol": "Rs"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Palau",
    "code": "PW",
    "phoneCode": "+680",
    "currency": {
      "code": "USD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Palestinian Territory, Occupied",
    "code": "PS",
    "phoneCode": "+970",
    "currency": {
      "code": "ILS",
      "symbol": "₪"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Panama",
    "code": "PA",
    "phoneCode": "+507",
    "currency": {
      "code": "PAB",
      "symbol": "B/."
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Papua New Guinea",
    "code": "PG",
    "phoneCode": "+675",
    "currency": {
      "code": "PGK",
      "symbol": "K"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Paraguay",
    "code": "PY",
    "phoneCode": "+595",
    "currency": {
      "code": "PYG",
      "symbol": "₲"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Peru",
    "code": "PE",
    "phoneCode": "+51",
    "currency": {
      "code": "PEN",
      "symbol": "S/."
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Philippines",
    "code": "PH",
    "phoneCode": "+63",
    "currency": {
      "code": "PHP",
      "symbol": "₱"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Pitcairn",
    "code": "PN",
    "phoneCode": "+64",
    "currency": {
      "code": "NZD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Poland",
    "code": "PL",
    "phoneCode": "+48",
    "currency": {
      "code": "PLN",
      "symbol": "zł"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Portugal",
    "code": "PT",
    "phoneCode": "+351",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Puerto Rico",
    "code": "PR",
    "phoneCode": "+1",
    "currency": {
      "code": "USD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Qatar",
    "code": "QA",
    "phoneCode": "+974",
    "currency": {
      "code": "QAR",
      "symbol": "ر.ق"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Reunion",
    "code": "RE",
    "phoneCode": "+262",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Romania",
    "code": "RO",
    "phoneCode": "+40",
    "currency": {
      "code": "RON",
      "symbol": "L"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Russian Federation",
    "code": "RU",
    "languages": [
      {
        "code": "en_US",
        "short": "EN",
        "name": "English (US)",
        "default": true
      },
      {
        "code": "ru_RU",
        "short": "RU",
        "name": "Russian",
        "default": false
      },
      {
        "code": "sv_FI",
        "short": "FI",
        "name": "Finnish",
        "default": false
      }
    ],
    "phoneCode": "+7",
    "currency": {
      "code": "RUB",
      "symbol": "₽"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Rwanda",
    "code": "RW",
    "phoneCode": "+250",
    "currency": {
      "code": "RWF",
      "symbol": "RF"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Saint Helena",
    "code": "SH",
    "phoneCode": "+290",
    "currency": {
      "code": "SHP",
      "symbol": "£"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Saint Kitts and Nevis",
    "code": "KN",
    "phoneCode": "+1",
    "currency": {
      "code": "XCD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Saint Lucia",
    "code": "LC",
    "phoneCode": "+1",
    "currency": {
      "code": "XCD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "code": "PM",
    "phoneCode": "+508",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "code": "VC",
    "phoneCode": "+1",
    "currency": {
      "code": "XCD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Samoa",
    "code": "WS",
    "phoneCode": "+685",
    "currency": {
      "code": "WST",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "San Marino",
    "code": "SM",
    "phoneCode": "+378",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Sao Tome and Principe",
    "code": "ST",
    "phoneCode": "+239",
    "currency": {
      "code": "STD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Saudi Arabia",
    "code": "SA",
    "phoneCode": "+966",
    "currency": {
      "code": "SAR",
      "symbol": "ر.س"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Senegal",
    "code": "SN",
    "phoneCode": "+221",
    "currency": {
      "code": "CFA",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Serbia and Montenegro",
    "code": "CS",
    "phoneCode": "+381",
    "currency": {
      "code": "RSD",
      "symbol": "РСД"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Seychelles",
    "code": "SC",
    "phoneCode": "+248",
    "currency": {
      "code": "SCR",
      "symbol": "SR"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Sierra Leone",
    "code": "SL",
    "phoneCode": "+232",
    "currency": {
      "code": "SLL",
      "symbol": "Le"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Singapore",
    "code": "SG",
    "phoneCode": "+65",
    "currency": {
      "code": "SGD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Slovakia",
    "code": "SK",
    "phoneCode": "+421",
    "currency": {
      "code": "SKK",
      "symbol": "Sk"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Slovenia",
    "code": "SI",
    "phoneCode": "+386",
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Solomon Islands",
    "code": "SB",
    "phoneCode": "+677",
    "currency": {
      "code": "SBD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Somalia",
    "code": "SO",
    "phoneCode": "+252",
    "currency": {
      "code": "SOS",
      "symbol": "So."
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "South Africa",
    "code": "ZA",
    "phoneCode": "+27",
    "currency": {
      "code": "ZAR",
      "symbol": "R"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "South Georgia and the South Sandwich Islands",
    "code": "GS",
    "phoneCode": "+500",
    "currency": {
      "code": "GBP",
      "symbol": "£"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Spain",
    "code": "ES",
    "phoneCode": "+34",
    "languages": [
      {
        "code": "en_US",
        "short": "EN",
        "name": "English (US)",
        "default": true
      },
      {
        "code": "es_MX",
        "short": "ES",
        "name": "Spanish (MX)",
        "default": false
      }
    ],
    "currency": {
      "code": "EUR",
      "symbol": "€"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Sri Lanka",
    "code": "LK",
    "phoneCode": "+94",
    "currency": {
      "code": "LKR",
      "symbol": "L"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Sudan",
    "code": "SD",
    "phoneCode": "+249",
    "currency": {
      "code": "SDG",
      "symbol": "£"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Suriname",
    "code": "SR",
    "phoneCode": "+597",
    "currency": {
      "code": "SRD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Svalbard and Jan Mayen",
    "code": "SJ",
    "phoneCode": "+47",
    "currency": {
      "code": "NOK",
      "symbol": "Kr"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Swaziland",
    "code": "SZ",
    "phoneCode": "+268",
    "currency": {
      "code": "SZL",
      "symbol": "L"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Sweden",
    "code": "SE",
    "languages": [
      {
        "code": "en_US",
        "short": "EN",
        "name": "English (US)",
        "default": true
      },
      {
        "code": "sv_FI",
        "short": "FI",
        "name": "Finnish",
        "default": false
      }
    ],
    "phoneCode": "+46",
    "currency": {
      "code": "SEK",
      "symbol": "kr"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Switzerland",
    "code": "CH",
    "languages": [
      {
        "code": "ch_GE",
        "short": "GE",
        "name": "German",
        "default": true
      },
      {
        "code": "ch_FR",
        "short": "FR",
        "name": "French",
        "default": false
      },
      {
        "code": "ch_IT",
        "short": "IT",
        "name": "Italian",
        "default": false
      },
      {
        "code": "ch_EN",
        "short": "EN",
        "name": "English",
        "default": false
      }
    ],
    "phoneCode": "+41",
    "currency": {
      "code": "CHF",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Syrian Arab Republic",
    "code": "SY",
    "phoneCode": "+963",
    "currency": {
      "code": "SYP",
      "symbol": "£"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Taiwan, Province of China",
    "code": "TW",
    "phoneCode": "+886",
    "currency": {
      "code": "NTD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Tajikistan",
    "code": "TJ",
    "phoneCode": "+992",
    "currency": {
      "code": "TJS",
      "symbol": "SM"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Tanzania, United Republic of",
    "code": "TZ",
    "phoneCode": "+255",
    "currency": {
      "code": "TZS",
      "symbol": "x/y"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Thailand",
    "code": "TH",
    "phoneCode": "+66",
    "currency": {
      "code": "THB",
      "symbol": "฿"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Timor-Leste",
    "code": "TL",
    "phoneCode": "+670",
    "currency": {
      "code": "USD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Togo",
    "code": "TG",
    "phoneCode": "+228",
    "currency": {
      "code": "CFA",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Tokelau",
    "code": "TK",
    "phoneCode": "+690",
    "currency": {
      "code": "NZD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Tonga",
    "code": "TO",
    "phoneCode": "+676",
    "currency": {
      "code": "TOP",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Trinidad and Tobago",
    "code": "TT",
    "phoneCode": "+1",
    "currency": {
      "code": "TTD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Tunisia",
    "code": "TN",
    "phoneCode": "+216",
    "currency": {
      "code": "TND",
      "symbol": "د.ت"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Turkey",
    "code": "TR",
    "phoneCode": "+90",
    "currency": {
      "code": "TRY",
      "symbol": "TL"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Turkmenistan",
    "code": "TM",
    "phoneCode": "+993",
    "currency": {
      "code": "TMT",
      "symbol": "m"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Turks and Caicos Islands",
    "code": "TC",
    "phoneCode": "+1",
    "currency": {
      "code": "USD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Tuvalu",
    "code": "TV",
    "phoneCode": "+688",
    "currency": {
      "code": "TVD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Uganda",
    "code": "UG",
    "phoneCode": "+256",
    "currency": {
      "code": "UGX",
      "symbol": "USh"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Ukraine",
    "code": "UA",
    "phoneCode": "+380",
    "currency": {
      "code": "UGX",
      "symbol": "₴"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "United Arab Emirates",
    "code": "AE",
    "phoneCode": "+971",
    "currency": {
      "code": "AED",
      "symbol": "د.إ"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "United Kingdom",
    "code": "GB",
    "phoneCode": "+44",
    "currency": {
      "code": "GBP",
      "symbol": "£"
    },
    "languages": [
      {
        "code": "en_US",
        "short": "EN",
        "name": "English (US)",
        "default": true
      }
    ],
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y",
    "filters": [
      {
        "slug": "completed",
        "name": "Completed"
      },
      {
        "slug": "past",
        "name": "Past"
      },
      {
        "slug": "readyToShip",
        "name": "Ready To Ship"
      },
      {
        "slug": "inProgress",
        "name": "In Progress"
      },
      {
        "slug": "assignedByMe",
        "name": "Assigned By Me"
      },
      {
        "slug": "pendingMyApproval",
        "name": "Pending My Approval"
      },
      {
        "slug": "assignedToMe",
        "name": "Assigned to Me"
      },
      {
        "slug": "pendingShipperApproval",
        "name": "Pending Shipper Approval"
      },
      {
        "slug": "canceled",
        "name": "Canceled"
      },
      {
        "slug": "pendingMyAction",
        "name": "Pending My Action"
      },
      {
        "slug": "shipped",
        "name": "Shipped"
      },
      {
        "slug": "favorite",
        "name": "Favourite"
      }
    ]
  },
  {
    "name": "United States of America",
    "code": "US",
    "languages": [
      {
        "code": "en_US",
        "short": "EN",
        "name": "English (US)",
        "default": true
      }
    ],
    "phoneCode": "+1",
    "currency": {
      "code": "USD",
      "symbol": "$"
    },
    "dimensions": "in",
    "weight": "lb",
    "dateFormat": "m/d/y",
    "filters": [
      {
        "slug": "completed",
        "name": "Completed"
      },
      {
        "slug": "past",
        "name": "Past"
      },
      {
        "slug": "readyToShip",
        "name": "Ready To Ship"
      },
      {
        "slug": "inProgress",
        "name": "In Progress"
      },
      {
        "slug": "assignedByMe",
        "name": "Assigned By Me"
      },
      {
        "slug": "pendingMyApproval",
        "name": "Pending My Approval"
      },
      {
        "slug": "assignedToMe",
        "name": "Assigned to Me"
      },
      {
        "slug": "pendingShipperApproval",
        "name": "Pending Shipper Approval"
      },
      {
        "slug": "canceled",
        "name": "Canceled"
      },
      {
        "slug": "pendingMyAction",
        "name": "Pending My Action"
      },
      {
        "slug": "shipped",
        "name": "Shipped"
      },
      {
        "slug": "favorite",
        "name": "Favorite"
      }
    ]
  },
  {
    "name": "United States Minor Outlying Islands",
    "code": "UM",
    "phoneCode": "+1",
    "currency": {
      "code": "USD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Uruguay",
    "code": "UY",
    "phoneCode": "+598",
    "currency": {
      "code": "UYU",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Uzbekistan",
    "code": "UZ",
    "phoneCode": "+998",
    "currency": {
      "code": "UZS",
      "symbol": "som"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Vanuatu",
    "code": "VU",
    "phoneCode": "+678",
    "currency": {
      "code": "VUV",
      "symbol": "Vt"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Venezuela",
    "code": "VE",
    "phoneCode": "+58",
    "currency": {
      "code": "VEF",
      "symbol": "Bs."
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Vietnam",
    "code": "VN",
    "phoneCode": "+84",
    "currency": {
      "code": "VND",
      "symbol": "₫"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Virgin Islands, British",
    "code": "VG",
    "phoneCode": "+1",
    "currency": {
      "code": "GBP",
      "symbol": "£"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Virgin Islands, U.S.",
    "code": "VI",
    "phoneCode": "+1",
    "currency": {
      "code": "USD",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Wallis and Futuna",
    "code": "WF",
    "phoneCode": "+681",
    "currency": {
      "code": "CFP",
      "symbol": "₣"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Western Sahara",
    "code": "EH",
    "phoneCode": "+212",
    "currency": {
      "code": "MAD",
      "symbol": "د.م"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Yemen",
    "code": "YE",
    "phoneCode": "+967",
    "currency": {
      "code": "YER",
      "symbol": "﷼"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Zambia",
    "code": "ZM",
    "phoneCode": "+260",
    "currency": {
      "code": "ZMW",
      "symbol": "ZK"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  },
  {
    "name": "Zimbabwe",
    "code": "ZW",
    "phoneCode": "+263",
    "currency": {
      "code": "ZWL",
      "symbol": "$"
    },
    "dimensions": "cm",
    "weight": "kg",
    "dateFormat": "d/m/y"
  }
],
    regions: [
  {
    "name": "North America",
    "viewBox": "-40 150 630 400",
    "fill": "#8CCCCC",
    "fillMuted": "#c3e3e2",
    "fillPartner": "#add9da",
    "stroke": "#67A5AE",
    "kpis": [
      {
        "title": "49,685",
        "description": "Employees <sup>1</sup>"
      },
      {
        "title": "3,721,230",
        "description": "m² of Storage <sup>2</sup>"
      },
      {
        "title": "493",
        "description": "Warehouses and Offices <sup>2</sup>"
      }
    ]
  },
  {
    "name": "Latin America",
    "viewBox": "0 300 630 400",
    "fill": "#FBBF56",
    "fillMuted": "#fadcaa",
    "fillPartner": "#fbd189",
    "stroke": "#D2A24C",
    "kpis": [
      {
        "title": "38,100",
        "description": "Employees <sup>1</sup>"
      },
      {
        "title": "2,560,269",
        "description": "m² of Storage <sup>2</sup>"
      },
      {
        "title": "223",
        "description": "Warehouses and Offices <sup>2</sup>"
      }
    ]
  },
  {
    "name": "United Kingdom and Ireland",
    "viewBox": "500 220 107 100",
    "fill": "#90ADB1",
    "fillMuted": "#c4d3d5",
    "fillPartner": "#afc4c7",
    "stroke": "#B9C6CD",
    "kpis": [
      {
        "title": "39,750",
        "description": "Employees <sup>1</sup>"
      },
      {
        "title": "1,850,000",
        "description": "m² of Storage <sup>2</sup>"
      },
      {
        "title": "168",
        "description": "Warehouses and Offices <sup>2</sup>"
      }
    ]
  },
  {
    "name": "Europe, Middle East, and Africa",
    "viewBox": "500 150 350 450",
    "fill": "#99A768",
    "fillMuted": "#c8d0b1",
    "fillPartner": "#b5bf94",
    "stroke": "#91AA50",
    "kpis": [
      {
        "title": "33,852",
        "description": "Employees <sup>1</sup>"
      },
      {
        "title": "3,188,050",
        "description": "m² of Storage <sup>2</sup>"
      },
      {
        "title": "323",
        "description": "Warehouses and Offices <sup>2</sup>"
      }
    ]
  },
  {
    "name": "Asia Pacific",
    "viewBox": "620 220 700 450",
    "fill": "#CE9F53",
    "fillMuted": "#e4cca8",
    "fillPartner": "#dbba86",
    "stroke": "#C09C53",
    "kpis": [
      {
        "title": "41,717",
        "description": "Employees <sup>1</sup>"
      },
      {
        "title": "4,411,670",
        "description": "m² of Storage <sup>1</sup>"
      },
      {
        "title": "608",
        "description": "Warehouses and Offices <sup>1</sup>"
      }
    ]
  }
],
    solutions: [
  {
    "icon": "riveticon-warehouse",
    "name": "Warehousing",
    "slug": "warehouse",
    "countries": [
      "Saudi Arabia",
      "United States of America",
      "Canada",
      "Brazil",
      "Argentina",
      "Mexico",
      "Germany",
      "France",
      "Turkey",
      "Russia",
      "India",
      "Japan",
      "Thailand"
    ]
  },
  {
    "icon": "riveticon-truck_road_freight",
    "name": "Transport",
    "slug": "transport",
    "countries": [
      "Saudi Arabia",
      "United Kingdom",
      "Ireland",
      "Canada",
      "Brazil",
      "Argentina",
      "Mexico",
      "Germany",
      "France",
      "Finland",
      "Norway",
      "Turkey",
      "Russia",
      "India",
      "Japan"
    ]
  },
  {
    "icon": "riveticon-home",
    "name": "Real Estate",
    "slug": "real-estate",
    "countries": [
      "United Kingdom",
      "Ireland",
      "United States of America",
      "Saudi Arabia",
      "Canada",
      "Brazil",
      "Argentina",
      "Mexico",
      "Germany",
      "France",
      "Spain",
      "Portugal",
      "Finland",
      "Norway",
      "Turkey",
      "Russia",
      "India",
      "Japan"
    ]
  },
  {
    "icon": "riveticon-primary_secondary_packaging",
    "name": "Packaging",
    "slug": "packaging",
    "countries": [
      "United States of America",
      "United Kingdom",
      "Ireland",
      "Canada",
      "Brazil",
      "Argentina",
      "Mexico",
      "Germany",
      "France",
      "Finland",
      "Norway",
      "Turkey",
      "Russia",
      "India",
      "Japan"
    ]
  },
  {
    "icon": "riveticon-shopping_cart_ecommerce",
    "name": "E-Commerce Fulfillment",
    "slug": "ecommerce",
    "countries": [
      "United States of America",
      "Canada",
      "Brazil",
      "Argentina",
      "Mexico",
      "Germany",
      "France",
      "Turkey",
      "Russia",
      "India",
      "Japan"
    ]
  },
  {
    "icon": "riveticon-management_services",
    "name": "Service Logistics",
    "slug": "service-logistics",
    "countries": [
      "United Kingdom",
      "Ireland",
      "United States of America",
      "Canada",
      "Brazil",
      "Argentina",
      "Mexico",
      "Germany",
      "France",
      "Turkey",
      "Russia",
      "India",
      "Japan"
    ]
  },
  {
    "icon": "riveticon-management",
    "name": "Lead Logistics Partner",
    "slug": "lead-logistics-partner",
    "countries": [
      "United States of America",
      "Spain",
      "South Africa",
      "Canada",
      "Brazil",
      "Argentina",
      "Mexico",
      "Germany",
      "France",
      "Turkey",
      "Russia",
      "India",
      "Japan"
    ]
  }
],
    industries: [
  {
    "icon": "riveticon-auto_mobility",
    "name": "Auto-Mobility",
    "slug": "automobility",
    "countries": [
      "United States of America",
      "Saudi Arabia",
      "United Kingdom",
      "Ireland",
      "Canada",
      "Brazil",
      "Argentina",
      "Mexico",
      "Germany",
      "France",
      "Finland",
      "Norway",
      "Turkey",
      "Russia",
      "India",
      "Japan"
    ]
  },
  {
    "icon": "riveticon-shopping_cart",
    "name": "Consumer Goods",
    "slug": "consumer",
    "countries": [
      "Saudi Arabia",
      "United States of America",
      "Canada",
      "Brazil",
      "Argentina",
      "Mexico",
      "Germany",
      "France",
      "Turkey",
      "Russia",
      "India",
      "Japan"
    ]
  },
  {
    "icon": "riveticon-engineering",
    "name": "Engineering and Manufacturing, Energy and Chemicals",
    "slug": "engineering",
    "countries": [
      "Saudi Arabia",
      "United Kingdom",
      "Ireland",
      "United States of America",
      "Canada",
      "Brazil",
      "Argentina",
      "Mexico",
      "Germany",
      "France",
      "Turkey",
      "Russia",
      "India",
      "Japan"
    ]
  },
  {
    "icon": "riveticon-lsh",
    "name": "Life Science and Healthcare",
    "slug": "healthcare",
    "countries": [
      "United States of America",
      "Saudi Arabia",
      "Canada",
      "Brazil",
      "Argentina",
      "Mexico",
      "Germany",
      "France",
      "Finland",
      "Norway",
      "Turkey",
      "Russia",
      "India",
      "Japan"
    ]
  },
  {
    "icon": "riveticon-retail_sector",
    "name": "Retail",
    "slug": "retail",
    "countries": [
      "United Kingdom",
      "Ireland",
      "United States of America",
      "Canada",
      "Brazil",
      "Argentina",
      "Mexico",
      "Germany",
      "France",
      "Turkey",
      "Russia",
      "India",
      "Japan"
    ]
  },
  {
    "icon": "riveticon-technology",
    "name": "Technology",
    "slug": "technology",
    "countries": [
      "United States of America",
      "Canada",
      "Brazil",
      "Argentina",
      "Mexico",
      "Germany",
      "France",
      "Finland",
      "Norway",
      "Turkey",
      "Russia",
      "India",
      "Japan"
    ]
  }
],
    latinAmerica: [
  "Argentina",
  "Bolivia",
  "Brazil",
  "Chile",
  "Colombia",
  "Ecuador",
  "Mexico",
  "Paraguay",
  "Peru",
  "Uruguay",
  "Venezuela"
],
    europe: [
  "Austria",
  "Belgium",
  "Czech Republic",
  "Denmark",
  "Finland",
  "France",
  "Germany",
  "Hungary",
  "Italy",
  "Kenya",
  "Netherlands",
  "Norway",
  "Poland",
  "Portugal",
  "Saudi Arabia",
  "Slovakia",
  "South Africa",
  "Spain",
  "Sweden",
  "Tanzania",
  "Turkey",
  "Uganda"
],
    asiaPacific: [
  "Australia",
  "India",
  "Indonesia",
  "Japan",
  "Korea",
  "Malaysia",
  "Myanmar",
  "New Zealand",
  "Philippines",
  "Singapore",
  "Taiwan",
  "Thailand",
  "Vietnam"
],
    northAmerica: [
  "Canada",
  "United States of America"
],
    ukIreland: [
  "United Kingdom",
  "Ireland"
],
    caseStudies: [
  {
    "id": "volkswagen",
    "title": "Local Knowledge and Global Strength Transforms In-House Logistics",
    "content": "<p><b>Volkswagen’s Challenge</b>: Required services for inbound receipt, storage, picking and knitting, sequencing and replenishment and delivery of materials directly to production lines. Switching must be complete in a 10-week timeframe.</p><p><b>Solution</b>: ​​We formulated a detailed transition strategy that accommodated personnel increases at short notice, introduced innovative managerial approaches such as job rotation and used a wide range of internal media from print to screen to communicate changes and new processes to staff.</p><p><b>Results</b>: Increase to 12,000 stock orders processed daily, 100% increase in personnel, reduced personnel issues, costs per capita and picking and allocation errors and decrease in line stoppages and downtime.</p><p>“In the first year of our partnership with DHL we managed together the goals we have set. Volkswagen Slovakia is becoming the benchmark in the logistics processes including in-house logistics operations and considering the forthcoming challenges related to new product launches and increasing production, we require partners that are the best among the best.”  - Juraj Janác, Head of Logistics Volkswagen Slovakia</p>",
    "image": "images/case-studies/image3.png",
    "links": [
      { "title": "Explore Lead Logistics Partner Service", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/lead-logistics-partner.html" },
      { "title": "Learn about our Automobility Expertise", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/auto-mobility.html" }
    ],
    "sectors": [
      { "icon": "riveticon-management", "name": "Lead Logistics Partner" },
      { "icon": "riveticon-auto_mobility", "name": "Auto-Mobility", "color": "blue" }
    ]
  },
  {
    "id": "tiendanimal",
    "title": "Quick Action Helps Turn Lockdown Restrictions into E-commerce Success",
    "content": "<p><b>Tiendanimal’s Challenge</b>: Forced to close 75% of its physical locations due to Covid-19 lockdown restrictions, Tiendanimal’s in-store sales fell precipitously while e-commerce sales skyrocketed by 200%. Tiendanimal’s e-commerce operation simply wasn’t in a position to handle an unexpected tripling in demand and had to greatly upscale its e-commerce capabilities quickly. A process that normally takes months to plan and implement had to happen more-or-less overnight without increasing staff and supporting social distancing.</p><p><b>Solution</b>: In less than a week, DHL had entirely repurposed Tiendanimal’s distribution center, allowing the business to upscale its e-commerce. DHL oversaw the installation of eight ‘Chuck’ robots. Using machine learning to become increasingly efficient over time, Chucks can pick, pack, sort, count and replenish, allowing their human colleagues to focus on other tasks.</p><p><b>Results</b>: Within a matter of weeks of Tiendanimal opening its e-commerce channel, DHL was picking, packing and delivering more than 6,000 products a day on the company’s behalf.</p>",
    "image": "images/case-studies/image5.png",
    "links": [
      { "title": "Explore E-Commerce Fulfillment Solutions", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/ecommerce-fulfillment.html" },
      { "title": "Learn about our expertise in Retail", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/retail.html" }
    ],
    "sectors": [
      { "icon": "riveticon-shopping_cart_ecommerce", "name": "E-Commerce Fulfillment" },
      { "icon": "riveticon-retail_sector", "name": "Retail", "color": "blue" }
    ]
  },
  {
    "id": "johnson-johnson",
    "title": "Comprehensive Warehousing Solution Improves Distribution of Marketing Materials",
    "content": "<p><b>Johnson & Johnson Medical’s Challenge</b>: Decentralized and unstandardized internal order process for advertising and marketing materials resulted in slow dispatch speed and a lack of transparency that impeded goal-oriented business optimizations.</p><p><b>Solution</b>: We launched a customized webshop as a company wide order platform, integrated IT and warehouse processes, automated stock management and provided for event and fair support (e.g., time definite shipments to exhibition location).</p><p><b>Results</b>: As a result, Johnson & Johnson Medical realized improved delivery times with increased shipment quality, inventory visibility and cost transparency and created a reliable basis and scalability for future strategic decisions.</p>",
    "image": "images/case-studies/image2.jpg",
    "links": [
      { "title": "Explore Warehousing Solutions", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/warehousing.html" },
      { "title": "Learn about our expertise in Life Science & Healthcare", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/life-sciences-and-healthcare.html" }
    ],
    "sectors": [
      { "icon": "riveticon-warehouse", "name": "Warehousing" },
      { "icon": "riveticon-lsh", "name": "Life Science and Healthcare", "color": "blue" }
    ]
  },
  {
    "id": "multinational-retailer",
    "title": "Fast Data Integration Enables E-commerce Growth During the Pandemic",
    "content": "<p><b>Retailer’s Challenge</b>: This worldwide leader in clothes, accessories and personal care products with more than a thousand stores in 28 countries found themselves needing to quickly ramp up their e-commerce capabilities in Mexico. With the closing of malls during the Covid-19 lockdown, they required an order fulfillment system that would integrate the last mile of each order and at the same time offer the customer order visibility.</p><p><b>Solution</b>: Our solution facilitates the real-time connection between the retailer and last mile carrier to offer visibility along the supply chain and have a shipping manifest for each delivery. The solution includes a high service level designed for product delivery within 48 hours upon ordering.</p><p><b>Results</b>: The solution, implemented in only nine weeks, resulted in efficient stock control for more than 18,000 SKU’s and helped to maintain the level of sales during the pandemic. Moreover, the optimal management of product collections also reduced the percentage of obsolete merchandise from previous seasons.</p>",
    "image": "images/case-studies/image6.jpg",
    "links": [
      { "title": "Explore Warehousing Solutions", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/warehousing.html" },
      { "title": "Learn about our expertise in Retail", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/retail.html" }
    ],
    "sectors": [
      { "icon": "riveticon-warehouse", "name": "Warehousing" },
      { "icon": "riveticon-retail_sector", "name": "Retail", "color": "blue" }
    ]
  },
  {
    "id": "multinational-convenience-store",
    "title": "Improving Freshness and Variety of Goods with a CDC Service Solutions",
    "content": "<p><b>Company's Challenge</b>: This U.S.-based chain of convenience stores that operates, franchises and licenses tens of thousands of stores around the world engaged us to provide combined distribution center (CDC) services. Very few of the retailer’s stores have the capacity to stock inventory, so it must coordinate and execute daily deliveries to every location. With a reputation for the quality and freshness of its products, the retailer set a goal to enable more frequent and regular deliveries of products, and ultimately increase sales.</p><p><b>Solution</b>: In collaboration with the retailer and its strategic partners in North America, we established a delivery operation that minimizes the number of daily deliveries to stores from multiple suppliers. The comprehensive solution includes managing the warehouse fresh delivery network operations, from bulk receiving to order fulfillment, delivery and customer service to each participating retail store.</p><p><b>Results</b>: Each year for this customer, DHL coordinates and executes more than 60,000 store deliveries and handles nearly 4,000 SKUs. To ensure quality and freshness, stringent product-handling and temperature standards are adhered to at the CDCs and the docks themselves are temperature-controlled. Ultimately, the organization reduced the cost of goods within the franchise model.</p>",
    "image": "images/case-studies/image4.png",
    "links": [
      { "title": "Explore Warehousing Solutions", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/warehousing.html" },
      { "title": "Learn about our expertise in Retail", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/retail.html" }
    ],
    "sectors": [
      { "icon": "riveticon-warehouse", "name": "Warehousing" },
      { "icon": "riveticon-truck_road_freight", "name": "Transport" },
      { "icon": "riveticon-retail_sector", "name": "Retail", "color": "blue" }
    ]
  },
  {
    "id": "aftermarket-filtration",
    "title": "Strategic Approach to Supply Chain Overhaul Improves KPIs",
    "content": "<p><b>Company's Challenge</b>: The company’s real estate network included two distribution centers – both in North Carolina – to service the entire country. This geographically consolidated footprint, coupled with increasingly stringent customer requirements, created challenges including lengthy lead times for customers on the west coast, undesirable customer service levels and high transportation costs.</p><p><b>Solution</b>: We leveraged our automotive industry expertise to identify ideal facility locations, and design warehousing, packaging, eCommerce order fulfilment and other value-added services solutions. The updated real estate footprint includes two new state-of-the-art distribution centers located in Nevada and South Carolina. The 400,000-square-foot Nevada site represents the customer’s first expansion into the western region. The South Carolina site consolidated the two existing distribution centers into a newly constructed space of 1.4 million square feet – a $92.7 million investment.</p><p><b>Results</b>: Modernized technology within the warehouses promotes more efficient throughput and better customer service including handling 50,000 ship-to destinations. Consolidating two older facilities into one, and opening a west coast operation, provided updated geographic positioning that delivers network and transportation efficiencies and also improves customer service metrics.</p>",
    "image": "images/case-studies/image1.png",
    "links": [
      { "title": "Explore Real Estate Solutions", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/real-estate.html" },
      { "title": "Learn about our expertise in Auto-Mobility", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/auto-mobility.html" }
    ],
    "sectors": [
      { "icon": "riveticon-home", "name": "Real Estate" },
      { "icon": "riveticon-warehouse", "name": "Warehousing" },
      { "icon": "riveticon-primary_secondary_packaging", "name": "Packaging" },
      { "icon": "riveticon-shopping_cart_ecommerce", "name": "E-Commerce Fulfillment" },
      { "icon": "riveticon-auto_mobility", "name": "Auto-Mobility", "color": "blue" }
    ]
  },
  {
    "id": "wine-subscription",
    "title": "Customized Picking Solutions Improves Capacity and Service",
    "content": "<p><b>Wine Company’s Challenge</b>: In conjunction with partners, this customer operates a subscription-based wine delivery service. Each year nearly 12 million bottles are packed and just under 1 million cases shipped. Around 55% of orders are for selections of wines that the customer themselves has chosen. The company needed a new process to speed these customized orders and ensure compliance with alcoholic beverage regulations that differ from state to state within the U.S.</p><p><b>Solution</b>: We designed a highly-customized solution that included a new JDA warehouse management system which offered flexibility and scalability. We specially engineered a picking cart that can complete around 30 customer orders in one travel sequence. These heavy carts are ergonomically designed and fitted with roller beds so the contents can be rolled onto a conveyor belt. The new process also adds the protective packaging, labels and enables the logo of the company’s partner to be printed on the box, together with the necessary regulatory information required by each state.</p><p><b>Results</b>: With a new warehouse management system in place the company can be assured that it is complying with the multiple regulatory regimes for alcohol and has been able to launch an app to its customers so they can find the status of their order, and even make changes to the assortment of wines.</p>",
    "image": "images/case-studies/image7.jpg",
    "links": [
      { "title": "Explore Warehousing Solutions", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/warehousing.html" },
      { "title": "Learn about our expertise in Consumer Goods", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/consumer-goods.html" }
    ],
    "sectors": [
      { "icon": "riveticon-warehouse", "name": "Warehousing" },
      { "icon": "riveticon-primary_secondary_packaging", "name": "Packaging" },
      { "icon": "riveticon-shopping_cart_ecommerce", "name": "E-Commerce Fulfillment" },
      { "icon": "riveticon-shopping_cart", "name": "Consumer Goods", "color": "blue" }
    ]
  },
  {
    "id": "toshiba",
    "title": "Toshiba Uses Leading Edge TMS to Cut Transport Costs",
    "content": "<p><b>Toshiba’s Challenge</b>: Toshiba America Business Solutions, Inc. (TABS) provides and distributes copier and fax machines along with parts and toner. TABS operated its distribution centers using a basic warehouse management system (WMS) that could not provide proper routing. Orders dropped by default routing regardless of required service levels, carrier preference or freight pay requirements. Orders were managed manually.</p><p><b>Solution</b>: To begin the transition to a more robust Transportation Management Solutions(TMS), we performed a comprehensive review of the transportation networks for both high-value assets and less costly replacement service parts being shipped. To determine the best transportation management solution, we conducted a high-level analysis to make sure the network looked and performed as expected. Additionally, the TMS automated order management and mode selection, which meant TABS did not have to rely on individuals’ judgment.</p><p><b>Results</b>: The system solved the majority of TABS’ transportation challenges and enabled them to reduce freight costs by 15 percent.</p><p>“By dynamically optimizing the routing of our freight and using the excellent data provided to better manage and negotiate, we were able to achieve freight savings for our valuable customers and Toshiba. Our results have been great and just as importantly, we have a platform for continuous improvement.”</p><p>R. Steven Tungate, VP/GM, Supply Chain and Innovation, TABS, Inc.</p>",
    "image": "images/case-studies/dpdhl_605001727259568_19_05_DHL_17132_small.jpg",
    "links": [
      { "title": "Explore Transport Solutions", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/transport.html" },
      { "title": "Learn about our expertise in Technology", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/technology.html" }
    ],
    "sectors": [
      { "icon": "riveticon-truck_road_freight", "name": "Transport" },
      { "icon": "riveticon-technology", "name": "Technology", "color": "blue" }
    ]
  },
  {
    "id": "pharmaceuticals",
    "title": "Integrated Packaging and Warehousing Addresses Challenges of Seasonal Products",
    "content": "<p><b>Company's Challenge</b>: A leading life sciences and consumer packaged goods company with revenues of more than $40 billion faced a challenge with scaling for peak season. Sun care and allergy relief products are purchased primarily in the summer months. The company therefore needed a logistics partner that could operate efficiently at maximum capacity for the peak three-month period that accounts for up to 80% of its revenue from such products.</p><p><b>Solution</b>: By integrating the co-packing and warehousing solution DHL was able to provide the required speed to market and cost efficiency. To meet the seasonality challenge, DHL operates two 10-hour shifts for four days during the peak period. With dual-purpose repack and display fulfilment lines we direct new SKUs right to outbound staging so that both shipping costs and time to market are reduced.</p><p><b>Results</b>:  As a result of this integrated approach, simplifying the packaging and warehousing processes, the company has achieved double digit cost savings. Transportation costs have been reduced, and the cost per unit has also decreased. The lead time has also been shortened significantly.</p>",
    "image": "images/case-studies/dpdhl_3226536921684113_genre_dhlbeauty-00103_small.jpg",
    "links": [
      { "title": "Explore Packaging Solutions", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/packaging.html" },
      { "title": "Learn about our expertise in Life Science and Healthcare", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/life-sciences-and-healthcare.html" }
    ],
    "sectors": [
      { "icon": "riveticon-primary_secondary_packaging", "name": "Packaging" },
      { "icon": "riveticon-warehouse", "name": "Warehousing" },
      { "icon": "riveticon-lsh", "name": "Life Science and Healthcare", "color": "blue" }
    ]
  },
  {
    "id": "residential-air-conditioning",
    "title": "Integrated Real Estate Solution Reduces Complexity and Minimizes Costs",
    "content": "<p><b>Company's Challenge</b>: For the global leader in residential air conditioning, new government-mandated seasonal energy efficiency ratio (SEER) standards necessitated changes to product design that impacted storage and distribution processes. When the SEER standards increased the size and weight of its air conditioning units by approximately 30 percent, the manufacturer was forced to consider an expansion to its manufacturing plant and primary plant distribution center – located 15 miles from the plant.</p><p><b>Solution</b>: We began by engaging our internal design teams to model fuel costs, number of deliveries and rental expenses to determine the optimal cost search radius. Because we aren’t a landlord, we objectively evaluate and present all possible options. When a suitably large building could not be found, we recommended a build-to-suit facility located, approximately eight miles across the Mississippi border that also leveraged tax incentives in that state. As the developer, our real estate team managed the timeline and all aspects of the project. The project broke ground in May, was completed in December and began operations in February.</p><p><b>Results</b>: Serving as the single point of contact from real estate through operations enabled us to reduce project complexity, negotiate $1.8M in economic incentives, reduce future costs due to transportation efficiencies and reduce the company’s capital investment and long-term risk.</p>",
    "image": "images/case-studies/dpdhl_1029805_35662_20170802_DHL_47_small.jpg",
    "links": [
      { "title": "Explore Real Estate Solutions", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/real-estate.html" },
      { "title": "Learn about our expertise in Engineering and Manufacturing, Energy and Chemicals", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/engineering-and-manufacturing-energy-and-chemicals.html" }
    ],
    "sectors": [
      { "icon": "riveticon-home", "name": "Real Estate" },
      { "icon": "riveticon-engineering", "name": "Engineering and Manufacturing, Energy and Chemicals", "color": "blue" }
    ]
  },
  {
    "id": "telecommunications",
    "title": "Strategic Partnership Facilitates Supply Chain Consolidation and Complex (4G/5G) Rollout",
    "content": "<p><b>Company's Challenge</b>: In 2016 this telecommunications giant underwent a significant transformation after a successful acquisition. Following the transaction, the company needed to integrate supply chains with its newly acquired business - seeking to realize cost savings while minimizing impact to their customers. To deliver major 4G and 5G roll-outs, they also required its logistics partner to provide flexibility, agility and scalability in the provision of a high volume and wide range of telecom products and warranty service parts.</p><p><b>Solution</b>: We worked together to develop a suite of solutions that would ensure a smooth transition and support the acceleration of synergies between the two businesses. Solutions included receiving, picking, packing and shipping services, kitting, product inspection and testing as well as inventory management, providing inventory visibility and optimizing slotting locations. We share a commitment to innovation and digitalization that has resulted in improved visibility on the movement of products and people in the warehouse.</p><p><b>Results</b>: At the warehouse there has been an improvement in productivity, with one-time shipping and receiving in excess of 99%, and a reduction in the cost per sales order line. Continuous improvement projects and innovation projects have been successfully implemented. Both companies continue their partnership to drive transformation in the digital supply chain.</p>",
    "image": "images/case-studies/dpdhl_37622885781440_19_05_DHL_20848_small.jpg",
    "links": [
      { "title": "Explore Lead Logistics Partner", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/lead-logistics-partner.html" },
      { "title": "Learn about our expertise in Technology", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/engineering-and-manufacturing-energy-and-chemicals.html" }
    ],
    "sectors": [
      { "icon": "riveticon-management", "name": "Lead Logistics Partner" },
      { "icon": "riveticon-technology", "name": "Technology", "color": "blue" }
    ]
  },
  {
    "id": "leading-retailer-warehousing",
    "title": "Voice Picking Solution Increases Productivity and Accuracy",
    "content": "<p><b>Retailer’s Challenge</b>: This leading retailer wanted to improve the efficiency of their fulfillment operations and decrease their customers’ complaints by 50%. The solution needed to be deployed quickly at one location for  minimum cost. They also wanted to define a standard solution that could eventually be at other locations.</p><p><b>Solution</b>: We implemented a flexible voice picking system Lydia® from Topsystem. The voice picking module provides real-time picking data and is integrated with the existing warehouse management system technology at the site.</p><p><b>Results</b>: After just five weeks,  productivity increased by 8% and 14% after just four months. Approximately 2,177 hours were saved, equating to over EUR 50,000 per annum. Customer complaints also decreased by 75% and transparency improved with real-time picking data. Based on the results the solution was deployed at two more of the customer’s sites.</p>",
    "image": "images/case-studies/dpdhl_1028479_32960_GB15_Florstadt_2_small.jpg",
    "links": [
      { "title": "Explore Warehousing Solutions", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/warehousing.html" },
      { "title": "Learn about our expertise in Retail", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/retail.html" }
    ],
    "sectors": [
      { "icon": "riveticon-warehouse", "name": "Warehousing" },
      { "icon": "riveticon-retail_sector", "name": "Retail", "color": "blue" }
    ]
  },
  {
    "id": "leading-retailer",
    "title": "IT Service Solution Supports Increased Volumes During Peak Periods",
    "content": "<p><b>Retailer’s Challenge</b>: This leading retailer in the United Kingdom needed a hosted solution that could accommodate additional users and an extra 225,000 parcels per week. The ​​IT solution needed to be delivered within just 24 weeks and include service level agreements in line with business critical operations.</p><p><b>Solution</b>: We assessed the current systems against its forecasted volumes to ensure the capacity was in place and then implemented customized levels of support onsite and remotely in line with the customer’s requirements. We included a dedicated steering group set up for each department within the operation to mitigate critical incidents and successfully integrated with the selected carrier management system. The new system is fully disaster resistant.</p><p><b>Results</b>: The business has grown the business by 275% over the last three years and fully met all of the customer’s agreed KPIs. The implementation was so successful that the solution has been replicated at a second site within the UK.</p>",
    "image": "images/case-studies/dpdhl_10303210921219089_mir-robotic-indoor-transport-warehouse-beringe-2_small.jpg",
    "links": [
      { "title": "Learn about our expertise in Retail", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/retail.html" }
    ],
    "sectors": [
      { "icon": "riveticon-retail_sector", "name": "Retail", "color": "blue" }
    ]
  },
  {
    "id": "nhs",
    "title": "Technology-Enabled Transport Provides Secure and Cost-Efficient Movement of Samples",
    "content": "<p><b>NHS’s Challenge</b>: Three NHS Trusts formed a partnership to offer a new model for consolidating pathology provision. The partnership seeks to provide modern, innovative and sustainable services that deliver outstanding quality. The partnership required similarly innovative logistics capabilities that could not only monitor the temperature of the pathology samples, but provide live information at the vehicle level. They also required the ability to carry out parent and child scanning and then be able to individually track each collection.</p><p><b>Solution</b>: Using a facility used for non-emergency patient transport services, we established a shared contact center to manage bookings. The service supports routine collection and delivery of samples on a 24/7/365 basis. Bookings made on the same day are supported in the first instance by motorbike transport services or, if not, by a screened partner. We also implemented the sample-level tracking using a standard Global Location Number on barcodes to identify collection and delivery points.</p><p><b>Results</b>: With the web-based booking system, there has been a significant reduction in labor-intensive telephone bookings and data entry. Pathology service users can now directly book, amend and cancel courier journeys, minimising cancellations.</p>",
    "image": "images/case-studies/dpdhl_604999788118215_19_05_DHL_35776_small.jpg",
    "links": [
      { "title": "Explore Transport Solutions", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/transport.html" },
      { "title": "Learn about our expertise in LIfe Science and Healthcare", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/life-sciences-and-healthcare.html" }
    ],
    "sectors": [
      { "icon": "riveticon-truck_road_freight", "name": "Transport" },
      { "icon": "riveticon-lsh", "name": "Life Science and Healthcare", "color": "blue" }
    ]
  },
  {
    "id": "automotive-manufacturer",
    "title": "Automated Order Sequencing Drives Efficiencies",
    "content": "<p><b>Automotive Manufacturer’s Challenge</b>: Moving to one large warehousing space from two smaller plants, this automotive manufacturer required an IT solution that could guide picking in a sequenced order at the new site and combine the sequenced supply of harnesses from its Tier 1 supplier. The solutions had to accommodate around 230 users per shift over a three shift day.</p><p><b>Solution</b>: We delivered full warehouse management at a single 325,000m² site and implemented Red Prairie Warehouse Management System (WMS) to guide picking in a sequenced order with more than  130 commodities added to the operation sequencing including brakes, calipers and mirrors. We also provided training and support to site users.</p><p><b>Results</b>: The new solution includes the capability to pick 500,000 sequenced items per week and the move to the new site frees up space at the two existing sites which could be used to support aggressive growth targets. The new solution reduced both resource costs and inventory costs due to improved visibility of stock moving through a just-in-time Supply Chain.</p>",
    "image": "images/case-studies/automotive.jpg",
    "links": [
      { "title": "Explore Warehousing Solutions", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/warehousing.html" },
      { "title": "Learn about our Automobility Expertise", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/auto-mobility.html" }
    ],
    "sectors": [
      { "icon": "riveticon-warehouse", "name": "Warehousing" },
      { "icon": "riveticon-auto_mobility", "name": "Auto-Mobility", "color": "blue" }
    ]
  },
  {
    "id": "global-tire-manufacturer",
    "title": "Development of Plant-to-Port Solution Responds to Global Demand ",
    "content": "<p><b>Tire Manufacturer’s Challenge</b>: With a joint venture established in Indonesia’s growing automotive hub, this global tire manufacturer needed a logistics partner that could provide the collaborative approach to exporting increasing volumes of synthetic rubber to domestic and global markets. It required a plant-to-port solution that offered scalable shipments with returns for non-compliant products, inbound and outbound product inspection, customs clearance, and rigorous specialist storage management and capacity.</p><p><b>Solution</b>: The solution leveraged on our industry-specific experience and consolidated the joint venture’s plant-to-port supply chain into a single solution, with DHL overseeing road freight transportation, warehousing and customs clearance.</p><p><b>Results</b>: With a focus on quality and safety that is crucial for innovative, world-class tire products, the new solution allows for faster, more scalable shipments of increasing volumes of synthetic rubber from factory to port, and can easily accommodate volume spikes.</p>",
    "image": "images/case-studies/1440_810_dhl-dsc-teaser-image-sector-expertise-tires.web.jpeg",
    "links": [
      { "title": "Explore Warehousing Solutions", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/warehousing.html" },
      { "title": "Learn about our Automobility Expertise", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/auto-mobility.html" }
    ],
    "sectors": [
      { "icon": "riveticon-truck_road_freight", "name": "Transport" },
      { "icon": "riveticon-warehouse", "name": "Warehousing" },
      { "icon": "riveticon-auto_mobility", "name": "Auto-Mobility", "color": "blue" }
    ]
  },
  {
    "id": "baycrew",
    "title": "Warehouse Consolidation Increases Capacity and Enables Growth",
    "content": "<p><b>Baycrew’s Challenge</b>: Baycrew operates more than 70 brands and sells their products via their retail stores and online channels. They operated from four warehouses. Each warehouse was  operated by a different 3PL vendor, hampering the easy movement of goods and overall stock transparency. Their e-commerce offering was growing but the warehouse was struggling to scale up. So Baycrew sought to build the number one logistics infrastructure and support their omni-channel growth plans.</p><p><b>Solution</b>: We consolidated Baycrew’s existing operations to their Kashiwa-shonan Logistics Centre. The facility has almost 50,000 square meters of space, room for 52 trucks and is within 30 km of the Narita and Haneda Airport. We also implemented a warehouse management system (WMS) bringing the retail and e-commerce inventories together and integrating with Baycrew’s core system for real-time inventory. Additional resource management and improvement processes were implemented.</p><p><b>Results</b>: The original goal of shipping 15,000 orders a day was achieved and increased to 25,000 within the one year. Inbound and outbound capacity has almost doubled from 120,000 items with 3 sites combined to 220,000 with a single site, thanks in part to the WMS accurately capturing both retail and e-commerce orders and allocating accordingly.</p>",
    "image": "images/case-studies/glo-dsc-fashion-bay-crews-body.web.1592.896.jpg",
    "links": [
      { "title": "Explore Warehousing Solutions", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/warehousing.html" },
      { "title": "Learn about our Retail Expertise", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/retail.html" }
    ],
    "sectors": [
      { "icon": "riveticon-warehouse", "name": "Warehousing" },
      { "icon": "riveticon-shopping_cart_ecommerce", "name": "E-Commerce Fulfillment" },
      { "icon": "riveticon-retail_sector", "name": "Retail", "color": "blue" }
    ]
  },
  {
    "id": "personal-care-products",
    "title": "Packaging Automation Improves Capacity and Quality",
    "content": "<p><b>Management's Challenge</b>: This fast moving consumer goods (FMCG) company manufactures some of the best known brands in personal care and baby care, which it sells in both mature and emerging markets.The company required primary and secondary promotional packaging, and had previously packaged its products using manual processes at a standard assembly table. However, the team was unable to cope with increasing demand and the quality was often inconsistent.</p><p><b>Solution</b>: To optimize the packaging process, we designed a custom two-tier assembly table with a conveyor system that can cater for multiple materials and components. The process begins with single-point feeding of materials from in front of the production line, reducing the amount of movement required by packagers. Additional improvements include multi-compartment bi, line balancing and automation of the film insertion and sealing process.</p><p><b>Results</b>: As a result of the new design process there has been an improvement of approximately 30% in packing line productivity. The introduction of automation has made the quality significantly more consistent and to the high standards that the company requires.</p>",
    "image": "images/case-studies/dpdhl_3226568875224322_genre_dhlbeauty-00110_large.jpg",
    "links": [
      { "title": "Explore Packaging Solutions", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/packaging.html" },
      { "title": "Learn about our Consumer Goods Expertise", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/consumer-goods.html" }
    ],
    "sectors": [
      { "icon": "riveticon-primary_secondary_packaging", "name": "Packaging" },
      { "icon": "riveticon-shopping_cart", "name": "Consumer Goods", "color": "blue" }
    ]
  },
  {
    "id": "sephora",
    "title": "Omni-Channel Fulfillment Improves Efficiency and Customer Satisfaction",
    "content": "<p><b>Sephora's Challenge</b>: Sephora is a multinational retailer of prestige cosmetics, personal care and other beauty products. It sells online and through its own physical stores. Due to the nature of many of the products, Sephora needed a partner that could manage product shelf-life, and deploy batch code tracking. This would serve to identify the product’s manufacturing and expiry dates, enabling strong controls around product quality and life cycle.</p><p><b>Solution</b>: Our solution for Sephora is based around a single inventory holding with outbound go-lives deployed in a phased approach, reducing any impact to the retail and e-commerce operations. In order to handle the large volumes required, automation has been incorporated into the logistics design in the form of a tailored, mechanized solution. This includes the use of a split case pick module, conveyor belt zone diverts and a sortation system.</p><p><b>Results</b>: The warehouse management system has improved operational efficiency and allowed visibility over stock and overall performance at the facility. Transportation costs have been reduced as a result of improved carton utilisation and delivery lead times to end customers have been cut, which has led to greater levels of customer satisfaction.</p>",
    "image": "images/case-studies/dpdhl_3228999610666732_genre_dhlbeauty-09932_small.jpg",
    "links": [
      { "title": "Explore E-Commerce Fulfillment", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/ecommerce-fulfillment.html" },
      { "title": "Learn about our Retail Expertise", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/retail.html" }
    ],
    "sectors": [
      { "icon": "riveticon-shopping_cart_ecommerce", "name": "E-Commerce Fulfillment" },
      { "icon": "riveticon-warehouse", "name": "Warehousing" },
      { "icon": "riveticon-retail_sector", "name": "Retail", "color": "blue" }
    ]
  },
  {
    "id": "semiconductor-company",
    "title": "Leveraging Logistics Expertise Improves Productivity and Optimizes Storage Space",
    "content": "<p><b>Management's Challenge</b>: This leading global semiconductor company in radio frequency (RF) power offers products and solutions used in a wide range of applications. Its operation in the Philippines served as both the company’s manufacturing plant and storage facility. Not only was this costly - as space at the plant is highly limited – but it restricted business growth. They needed support and expertise to manage their warehouse operations.</p><p><b>Solution</b>: Our local and regional design team analyzed the warehouse and network design, and proposed the optimal solution tailored to the customer’s needs. The supply chain solution was designed to minimize transitional and operational risks for scalability – something that is crucial for the semiconductor sector. The logistics activities provided include raw materials, die bank, spare parts, perishable materials, chemicals, finished goods and scrap management.</p><p><b>Results</b>: With the continuous growth of the customer, DHL has now expanded the warehouse to over 3,000 sqm. Today, the team recruits, trains and manages more than 100 dedicated local logistics professionals – Certified Supply Chain Specialists - to run the operations, continuously looking for ways to improve the way things are done.</p>",
    "image": "images/case-studies/dpdhl_1031837_39677_18_09_DHL_08319_small.jpg",
    "links": [
      { "title": "Explore Lead Logistics Partner", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/lead-logistics-partner.html" },
      { "title": "Learn about our Technology Expertise", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/technology.html" }
    ],
    "sectors": [
      { "icon": "riveticon-management", "name": "Lead Logistics Partner" },
      { "icon": "riveticon-technology", "name": "Technology", "color": "blue" }
    ]
  },
  {
    "id": "quick-service-restaurants",
    "title": "Cold Chain Solution Speeds Deliveries and Saves Cost",
    "content": "<p><b>Restaurant's Challenge</b>: This organization required frozen, cold chain and ambient warehouse and transport management to deliver a wide range of products including chilled and fresh produce. Operationally they want to improve efficiency of production, storage, transport, packaging and logistics operations.</p><p><b>Solution</b>: We provide cold chain and ambient warehousing including receiving of goods and storage. The solution integrated systems between DHL and the customer for streamlined order processing. Transportation services include door-to-door night deliveries to avoid interruption to daytime business, as well as regular route planning as new stores are introduced monthly.</p><p><b>Results</b>: The restaurant chain realized cost savings of 10% per annum, as well as faster delivery lead-time, lower inventory levels and in-transit stock. They also enjoyed end-to-end supply chain visibility with real-time tracking and tracing.</p>",
    "image": "images/case-studies/dpdhl_1032024_39864_18_09_DHL_29864_small.jpg",
    "links": [
      { "title": "Explore Transport Solutions", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/transport.html" },
      { "title": "Learn about our Consumer Goods Expertise", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/consumer-goods.html" }
    ],
    "sectors": [
      { "icon": "riveticon-truck_road_freight", "name": "Transport" },
      { "icon": "riveticon-shopping_cart", "name": "Consumer Goods", "color": "blue" }
    ]
  },
  {
    "id": "global-energy-company",
    "title": "Lead Logistics Partner Solution Improves Visibility, Cost and Compliance",
    "content": "<p><b>Management's Challenge</b>: This organization wanted to improve its supply chain visibility while also reducing logistics spend on fulfilling out of gauge and project shipment from its various business units. It had de-centralized management of 50+ carriers in the region and lacked a regional management team to respond to business needs.</p><p><b>Solution</b>: We rolled out Oracle Transport Management (OTM) to enable dynamic transport planning, optimize fleet and improve traceability. We also established an OTM-based freight bill and audit process to remove invoicing errors and created a regional management team to manage a wide range of carriers with a geo-centric approach. We reduced logistics spend with a more robust carrier selection process.</p><p><b>​Results</b>: Freight costs were lowered by 20% in years two and three. We improved HSSE compliance, service levels and visibility on both order and shipment level. Headcount was reduced and overall the organization realized a savings in APAC supply chain of USD 1.6 mil in 1.5 years.</p>",
    "image": "images/case-studies/dpdhl_18693506378189648_20200604_160225_CPH8704_small.png",
    "links": [
      { "title": "Explore Lead Logistics Partner", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/lead-logistics-partner.html" },
      { "title": "Learn about our expertise in Engineering and Manufacturing, Energy and Chemicals ", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/engineering-and-manufacturing-energy-and-chemicals.html" }
    ],
    "sectors": [
      { "icon": "riveticon-management", "name": "Lead Logistics Partner" },
      { "icon": "riveticon-engineering", "name": "Engineering and Manufacturing, Energy and Chemicals", "color": "blue" }
    ]
  },
  {
    "id": "chemical-manufacturing",
    "title": "Transport Solutions Improve Safety, Visibility and On-Time Performance",
    "content": "<p><b>Management's Challenge</b>: This organization was experiencing problems adhering to safety guidelines, challenges with on-time placement of vehicles and difficulty ensuring on-time delivery. They also suffered from low tracking visibility.</p><p><b>Solution</b>: Our solution included containerized vehicles with a dedicated operations team and driver and safety training. We ensured safety certification by customer and monitored vehicles through GPS.</p><p><b>Results</b>: With our strict adherence to safety requirements and continuous driver training and engagement, all in-plant safety expectations were met. We experienced no measurable transit damage reported or incidents reported, and reported 100% on-time performance.</p>",
    "image": "images/case-studies/glo-dsc-fracking-2.web.597.336.jpg",
    "links": [
      { "title": "Explore Transport Solutions", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/transport.html" },
      { "title": "Learn about our expertise in Engineering and Manufacturing, Energy and Chemicals", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/engineering-and-manufacturing-energy-and-chemicals.html" }
    ],
    "sectors": [
      { "icon": "riveticon-truck_road_freight", "name": "Transport" },
      { "icon": "riveticon-engineering", "name": "Engineering and Manufacturing, Energy and Chemicals", "color": "blue" }
    ]
  },
  {
    "id": "agricultural-chemical-provider",
    "title": "Integrated Solution with Control Tower Capabilities Ensures Safe Deliveries",
    "content": "<p><b>Management's Challenge</b>: This organization wanted to maintain its position as a market leader, against stiff competition and rising costs. They needed an end-to-end supply chain solution with visibility and traceability throughout the supply chain. Compliance with health, safety and local regulations were also a requirement as they needed a trusted dangerous goods (DG) expert to handle shipments compliant with ADR DG regulation.</p><p><b>Solution</b>: We assembled a nimble and experienced team that understood customer needs, design parameters and ideal flow of continuous operations. The solution set up a Control Tower, ensuring material is shipped at the right time and tracked from DHL to delivery locations. We also designed, selected and procured a fleet of trucks with ADR capabilities to handle DG cargo and trained DG experts to handle DG shipments according to global and local regulations.</p>​<p><b>Results</b>: The solution was implemented quickly with minimal disruption to operations. It reduced transportation costs and enabled full supply chain visibility. Regular performance measurement and continuous improvements ensure the solution remains safe and compliant with a focus on operational excellence.</p>",
    "image": "images/case-studies/dpdhl_1032263_40236_19_01_DHL_10005_small.jpg",
    "links": [
      { "title": "Explore Lead Logistics Partner ", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/lead-logistics-partner.html" },
      { "title": "Learn about our expertise in Engineering and Manufacturing, Energy and Chemicals", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/engineering-and-manufacturing-energy-and-chemicals.html" }
    ],
    "sectors": [
      { "icon": "riveticon-management", "name": "Lead Logistics Partner" },
      { "icon": "riveticon-engineering", "name": "Engineering and Manufacturing, Energy and Chemicals", "color": "blue" }
    ]
  },
  {
    "id": "warehouse-tenants",
    "title": "Energy Saving Program Supports Environmental Targets",
    "content": "<p><b>Challenge</b>: This facility runs 16 air handling units during Sydney‘s summer to maintain <25C degrees in the warehouse. Each handling unit was managed by a different team and the air conditioning set points were managed in the office environment.</p><p><b>Solution</b>: The solution was designed to keep cool air inside and hot air outside, reducing the reliance on air conditioning. Rapid roller doors and air curtains (with a vision to move to insulated roller doors) were installed. Roller doors were opened at half height during hotter days with less in and out traffic. The air conditioning was turned off for 4 – 5 months with QA approval and Off Peak MHE charging was implemented.</p><p><b>Results</b>: Cost saving of approximately $40,000 – $50,000 per site, per year. Cost reduction on charging and better routine for charging, due to delayed start/off peak.</p>",
    "image": "images/case-studies/dpdhl_3226836291072028_genre_dhlbeauty-00269_small.jpg",
    "links": [
      { "title": "Explore Real Estate Solutions ", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/real-estate.html" },
      { "title": "Learn about our expertise in Life Science and Healthcare ", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/life-sciences-and-healthcare.html" }
    ],
    "sectors": [
      { "icon": "riveticon-home", "name": "Real Estate" },
      { "icon": "riveticon-lsh", "name": "Life Science and Healthcare", "color": "blue" }
    ]
  },
  {
    "id": "medical-device-provider",
    "title": "Improving Field Inventory Management Reduces Supply Chain Costs",
    "content": "<p><b>Challenge</b>: For this medical device provider, high levels of inventory presented a particular challenge. They had minimal visibility and limited levels of stock accuracy. This led to duplication of high value products on multiple sites – costly both in financial terms and in levels of customer satisfaction. With product shelf life averaging five years or less, there was also the problem of obsolete or expired inventory and a lack of real-time information on order history and inventory availability.</p><p><b>Solution</b>: We designed and implemented a solution with glove-to-glove delivery (also known as same day delivery) to hospitals from GDP (Good Distribution Practice) compliant forward stock locations. This improved the visibility of inventory through the implementation of a global networked warehouse and transport management system and reduced the overall inventory holding requirements.</p><p><b>​Results</b>: There has been a reduction in the overall cost of the supply chain due to the reduction in the inventory holding requirements and the elimination of obsolete or expired stock. The new visibility of inventory availability has helped to improve service levels which in turn has led to increased customer satisfaction.</p>",
    "image": "images/case-studies/medical-devices.jpg",
    "links": [
      { "title": "Learn about our expertise in Life Science and Healthcare ", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/life-sciences-and-healthcare.html" },
      { "title": "Explore Service Logistics ", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/service-logistics.html" }
    ],
    "sectors": [
      { "icon": "riveticon-management_services", "name": "Service Logistics" },
      { "icon": "riveticon-lsh", "name": "Life Science and Healthcare", "color": "blue" }
    ]
  },
  {
    "id": "private-jet-manufacturer",
    "title": "Global Service Logistics Support keep the Jet Set Moving",
    "content": "<p><b>Jet Manufacturer’s Challenge</b>: To the powerful individuals who travel in private jets, there can be no satisfactory excuse for an aircraft’s failure to fly. Recognizing the importance of customer service to its long-term success and facing fierce competition to keep its industry-topping rating, this jet manufacturer had to make a change. The company’s parts supply chain had been linked to its commercial aircraft division and it was not optimized for the rapid response. Warehouses were not ideally located to support same-day or overnight parts delivery and items were sometimes delivered without the certification necessary for their use.</p><p><b>Solution</b>: We designed a solution to ensure the company’s 75 service centers in more than 60 countries are reliably and quickly supplied with parts. We established a global distribution center in Memphis, Tennessee. A regional hub in Brussels supports the mainland European, Middle Eastern and African operation, and there are forward stock locations in Dubai and Singapore. There are field stock locations close to strategic airports, where business aviation traffic is especially heavy.</p><p><b>Results</b>: On-time delivery is better than 99.5%. We have  maintained KPI scores above 99% against the targets in the service level agreement. Customer satisfaction has risen to 90%. Member surveys by the Professional Pilots’ Association have identified the jet manufacturer as number one for logistics service for four years running. In the Brussels operation alone, reduction in non-moving inventory has saved $4 million in six years.</p>",
    "image": "images/case-studies/manufacturing.jpg",
    "links": [
      { "title": "Explore Service Logistics ", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/solutions/service-logistics.html" },
      { "title": "Learn about our expertise in Engineering and Manufacturing, Energy and Chemicals ", "url": "https://www.dhl.com/us-en/home/our-divisions/dhl-supply-chain/industries/engineering-and-manufacturing-energy-and-chemicals.html" }
    ],
    "sectors": [
      { "icon": "riveticon-management_services", "name": "Service Logistics" },
      { "icon": "riveticon-engineering", "name": "Engineering and Manufacturing, Energy and Chemicals", "color": "blue" }
    ]
  }
],
    globalKpis: [
  {
    "title": "50+",
    "description": "Countries with Active Operations <sup>1</sup>"
  },
  {
    "title": "~1,500",
    "description": "Warehouses and Offices <sup>1,2</sup>"
  },
  {
    "title": "~15M",
    "description": "Square meters of storage <sup>1,2</sup>"
  },
  {
    "title": "160,000",
    "description": "Supply Chain Experts <sup>1</sup>"
  }
]
  };

  var ignoreLocationChange = false;

  var countryNames = [];

  var variables = {
    loadedMap: false,
    selectedCountry: null,
    selectedSelector: null,
    showLegend: false,
    showSidebar: 'solutions',
    viewSolutions: true,
    solution: null,
    country: null,
    changingCountry: null,
    modal: null,
    formAnimation: 'center',
    formType: null,
    formRegion: null, //'North America',
    formRegionAcronym: null,
    formFill: '#E9E9E9',
    formStroke: '#CCCCCC',
    regionCountries: [],
    caseStudyTitle: null,
    caseStudyContent: null,
    castStudySectors: []
  };

  _map.init = function() {
    updateDynamicContent(true);

    // Load the svg and inline it
    _utils.loadSVGasXML('images/dsc-world-map.svg', function(responseText) {
      var svg = $(responseText);
      $('#interactive-map #svg .map').append(svg);
      $('#interactive-map').addClass('interactive-map-loaded');

      resetMap();
      var china = document.getElementById('China');
      if (china) {
        china.classList.add('partner');
      }
      _map.setVariable('loadedMap', true);
      checkMapView(true);
      watchSVGDrag();
    });

    // Populate country names array
    data.countries.forEach(function(country) {
      countryNames.push(country.name);
    });

    // Initial content loops added to the page
    $('#interactive-map [data-for]').each(function(){
      forLoop($(this), data[$(this).data('for')]);
    });

    $('#interactive-map .map').on('click', function(event) {
      clicked(event);
    });

    $('#interactive-map .interactive-map, #interactive-map .interactive-map-modal').on('click', '[data-action]', actionsHandler);

    $('#interactive-map').on('click', '#caseStudyLinks .link', function() {
      sendEvent(this.innerText, 'Link', 'Case Study')
    })
  };

  // SET VARIABLE
  // Updating the variables object with this method allows us to react to changes
  // and trigger content updates on the page
  _map.setVariable = function(key, value) {
    if (variables[key] !== value) {
      variables[key] = value;
      //console.log('%cVariable Changed:\n' + key + ' = %o', 'color:#23dfa2;', value);
      updateDynamicContent();
    
      if (key === 'formRegion') {
        for (var i in data.regions) {
          if (data.regions[i].name === value) {
            data.kpis = data.regions[i].kpis;
            $('#interactive-map [data-for="kpis"]').each(function() {
              forLoop($(this), data.kpis);
            });
            break;
          }
        }
      }

      if (key === 'caseStudySectors') {
        $('#interactive-map [data-for="caseStudySectors"]').each(function() {
          forLoop($(this), variables.caseStudySectors);
        });
      }

      if (key === 'formRegionAcronym' && !ignoreLocationChange) {
        sendEvent(variables.formRegionAcronym + ' Region', 'Button', 'Map')
      }
    }
  };

  // UPDATE DYNAMIC CONTENT
  // Calling this method will toggle elements to show and hide, add and remove class names
  // and update text values based on the variables object.
  var timeouts = [];
  function updateDynamicContent(isInit) {
    for (var i = 0; i < timeouts.length; i++) {
      clearTimeout(timeouts[i]);
    }

    // If statements
    $('#interactive-map [data-if]').each(function() {
      var $elem = $(this);
      if (testConditions($(this).data('if'))) {
        $elem.css('display', '');
        if (isInit !== true && ($elem.hasClass('fadeinout') || $elem.hasClass('showsidebar'))) {
          timeouts.push(setTimeout(function() {
            $elem.removeClass('hidden');
          }, 20));
        } else {
          $elem.removeClass('hidden');
        }
      } else {
        $elem.addClass('hidden');
        if (isInit !== true && ($elem.hasClass('fadeinout') || $elem.hasClass('showsidebar'))) {
          timeouts.push(setTimeout(function() {
            $elem.css('display', 'none');
          }, 500));
        } else {
          $elem.css('display', 'none');
        }
      }
    });

    // Text values
    $('#interactive-map [data-text]').each(function() {
      var key = $(this).data('text');
      $(this).html(variables[key]);
    });

    // Conditional classes
    $('#interactive-map [data-class]').each(function() {
      if ($(this).closest('[data-for]').length === 0) {
        var classes = $(this).data('class').replace('{', '').replace('}', '').split(',');
        for (var i in classes) {
          var kvp = classes[i].split(': ');
          var className = kvp[0].replace(/'/g, '');
          if (testConditions(kvp[1])) {
            $(this).addClass(className);
          } else {
            $(this).removeClass(className);
          }
        }
      }
    });
  }

  // ACTION EVENT HANDLER
  // Handle all common click events.
  function actionsHandler(e) {
    e.preventDefault();
    var split = $(this).data('action').split('(');

    switch(split[0]) {
      case 'showLegend':
        if (!variables.showLegend) {
          sendEvent('Map Key', 'Button', 'Map')
        }
        _map.setVariable('showLegend', !variables.showLegend);
        break;
      case 'resetMap':
        resetMap();
        break;
      case 'viewSolutions':
        if (!variables.viewSolutions) {
          sendEvent('View Solutions & Industries', 'Button', 'Mobile Stats')
        }
        _map.setVariable('viewSolutions', !variables.viewSolutions);
        break;
      case 'showSolutionsSidebar':
        if (variables.showSidebar !== 'solutions') {
          sendEvent('Solution Selector', 'Button', 'Solution Selector')
        }
        _map.setVariable('showSidebar', variables.showSidebar === 'solutions' ? null : 'solutions');
        resetMap();
        break;
      case 'showIndustrySidebar':
        if (variables.showSidebar !== 'industry') {
          sendEvent('Industry Selector', 'Button', 'Industry Selector')
        }
        _map.setVariable('showSidebar', variables.showSidebar === 'industry' ? null : 'industry');
        resetMap();
        break;
      case 'showSolutions':
        showSolutions(split[1].substr(0, split[1].length - 1));
        break;
      case 'zoomViewBox':
        zoomViewBox(split[1].substr(0, split[1].length - 1));
        break;
      case 'closeModal':
        setModal(null);
        break;
    }
  }

  // FOR LOOP HELPER
  // A basic replacement for the Angular ngFor attribute so we can dynamically populate
  // and inject multiple elements using an inline hidden templete element.
  function forLoop($elem, items) {
    var key = $elem.data('for');
    var template = $elem.clone().removeAttr('data-for').attr('data-clone', key).prop('outerHTML');
    $elem.siblings('[data-clone]').remove();
    var html = '';
    for (var i in items) {
      var item = template;
      for (var n in items[i]) {
        item = item.replace('{{' + n + '}}', items[i][n]);
        item = item.replace('{{slug}}', items[i].slug);
      }
      html += item;
    }
    $elem.after(html);
  }

  // TEST CONDITIONS HELPER
  // A basic replacement for the Angular ngIf and class attributes so we can use simple
  // conditions in the view to prevent excessive JavaScript code to toggle each element.
  // This logic is not scoped and based on the variables used throughout the map element.
  function testConditions(statement) {
    // Or
    if (statement.indexOf('||') > -1) {
      var orConditions = statement.split(' || ');
      for (var i in orConditions) {
        if (testCondition(orConditions[i]) === true) {
          return true;
        }
      }
      return false;
    }
    // And
    else {
      var andConditions = statement.split(' && ');
      for (var n in andConditions) {
        if (testCondition(andConditions[n]) === false) {
          return false;
        }
      }
      return true;
    }
  }

  // TEST CONDITION HELPER
  // Used by the test conditions helper to test if a condition is true or false.
  function testCondition(condition) {
    if (condition.startsWith('!')) {
      var value = variables[condition.substr(1)];
      if (value === null || value === false) return true;
      if (value === true) return false;
      if (value !== null) return false;
    } else if (condition.indexOf('==') > -1) {
      var equalsKvp = condition.split(' == ');
      if (variables[equalsKvp[0]] !== equalsKvp[1].substring(1, equalsKvp[1].length-1)) return false;
    } else if (condition.indexOf('!=') > -1) {
      var notEqualsKvp = condition.split(' != ');
      if (variables[notEqualsKvp[0]] === notEqualsKvp[1].substring(1, notEqualsKvp[1].length-1)) return false;
    } else {
      if (variables[condition] === false || variables[condition] === null) return false;
    }

    return true;
  }

  // ADD STYLE BLOCK FOR REGION
  // Adds a background and border color specific to the region based on the JSON data
  function addFormStyles(stroke, fill, fillMuted, fillPartner) {
    $('#mapformstyles').remove();
    var css = '#interactive-map .active-operations { background: ' + fill + '; border: 1px solid ' + stroke + '; } #interactive-map .active-operations-muted { background: ' + fillMuted + '; border: 1px solid ' + stroke + '; } #interactive-map .active-operations-partner { background: ' + fillPartner + '; border: 1px solid ' + stroke + '; }';
    var head = document.getElementById('interactive-map');
    var style = document.createElement('style');
    //console.log(css, head)
    style.setAttribute('type', 'text/css');
    style.setAttribute('id', 'mapformstyles');
    head.appendChild(style);
    style.appendChild(document.createTextNode(css));
  }

  function sendEvent(name, type, position) {
    var event = new CustomEvent('dhl_utf_contentInteraction', {
      bubbles: true,
      detail: {
        content: {
          name: name,
          type: type,
          interaction: "Click",
          position: position,
          context: "Interactive Map"
        }
      }
    });
    window.dispatchEvent(event);
  }

  function clicked(event) {
    var ele = null;
    var type = null;

    if (
      event.target.id.includes(variables.selectedSelector) &&
      event.target.id != variables.selectedSelector &&
      !event.target.id.includes('/')
    ) {
      ele = event.target;
      type = 'selector';
    } else if (
      event.target.parentElement &&
      event.target.parentElement.id.includes(variables.selectedSelector) &&
      event.target.parentElement.id != variables.selectedSelector &&
      !event.target.parentElement.id.includes('/')
    ) {
      ele = event.target.parentElement;
      type = 'selector';
    } else if (
      event.target.parentElement &&
      event.target.parentElement.parentElement.id.includes(
        variables.selectedSelector
      ) &&
      event.target.parentElement.parentElement.id != variables.selectedSelector &&
      !event.target.parentElement.parentElement.id.includes('/')
    ) {
      ele = event.target.parentElement.parentElement;
      type = 'selector';
    } else if (
      event.target.parentElement &&
      event.target.parentElement.parentElement.parentElement.id.includes(
        variables.selectedSelector
      ) &&
      event.target.parentElement.parentElement.parentElement.id !=
      variables.selectedSelector &&
      !event.target.parentElement.parentElement.parentElement.id.includes('/')
    ) {
      ele = event.target.parentElement.parentElement.parentElement;
      type = 'selector';
    } else if (event.target.id.includes('point')) {
      type = 'point';
    } else if (
      event.target.parentElement &&
      event.target.parentElement.id.includes('point')
    ) {
      type = 'point';
    } else if (
      event.target.parentElement &&
      event.target.parentElement.parentElement.id.includes('point')
    ) {
      type = 'point';
    } else if (event.target.id) {
      if (
        countryNames.includes(
          toProperCase(event.target.id.replace(/-/g, ' ').toUpperCase())
        )
      ) {
        ele = event.target;

        var country = toProperCase(
          event.target.id.replace(/-/g, ' ').toUpperCase()
        );

        // if(this.latinAmerica.includes(country) || this.northAmerica.includes(country) || this.europe.includes(country) || this.ukIreland.includes(country) || this.middleEastAsiaPacific.includes(country)) {
        type = 'region';
        _map.setVariable('selectedCountry', event.target.id);
        _map.setVariable('country', country);
        _map.setVariable('changingCountry', country);
        // }
      }
    }

    if (type == 'region') {
      if (document.getElementById('World-Map')) {
        var groups = Array.from(document.getElementById('World-Map').children);
        groups.forEach(function (el) {
          if (el.id == 'map') {
            var tempRegion = null;
            var regions = Array.from(el.children);
            regions.forEach(function (region) {
              if (region.children) {
                var groups = Array.from(region.children);
                groups.forEach(function (country) {
                  // country.setAttribute("filter","null");
                  // country.classList.remove("filled");
                  var countryStr = ele.id.toLowerCase();
                  if (countryStr.toLowerCase() == country.id.toLowerCase()) {
                    hideLocations();
                    zoomToCountry(countryStr);
                    // if(countryStr.toLowerCase() == 'united-states-of-america') {x
                    if (window.innerWidth >= 1024) {
                      showLocations(region.id);
                    }
                    hideSolutions();
                    // } else {
                    //   this.hideLocations();
                    //   this.hideSolutions();
                    // }
                    tempRegion = region.id;

                    country.setAttribute('fill-opacity', '1');
                  } else if (countryStr) {
                    country.setAttribute('fill-opacity', '.5');
                  }
                });
              }
              // if(!tempRegion) {
              //   let groups = Array.from(region.children);
              //   groups.forEach((country: Element) => {
              //     country.setAttribute("opacity", ".2");
              //   });
              // }
            });
          }
        });
      }
    } else if (type == 'selector') {
      var str = ele.id;

      var region = str.toLowerCase().replace('solutions_', '');

      data.solutions.forEach(function (solution) {
        region = region.toLowerCase().replace(solution.slug + '_', '');
      });
      data.industries.forEach(function (industry) {
        region = region.toLowerCase().replace(industry.slug + '_', '');
      });

      var startIndex = region.indexOf('__');
      var endIndex = region.length;

      _map.setVariable('formId', region.substring(startIndex + 2, endIndex));

      region = region.substring(0, startIndex);
      region = toProperCase(
        region.replace(/-/g, ' ').toUpperCase().trim()
      );

      _map.setVariable('formRegion', region);
      if (variables.formRegion == 'North America') {
        // this.form.color = 'turquoise';
      }
      if (variables.formRegion == 'Latin America') {
        // this.form.color = 'orange';
      }
      if (variables.formRegion == 'Europe, Middle East, and Africa') {
        // this.form.color = 'blue';
      }
      if (variables.formRegion == 'Asia Pacific') {
        // this.form.color = 'yellow';
      }
      if (variables.formRegion == 'United Kingdom and Ireland') {
        // this.form.color = 'green';
      }

      var textElem = ele.querySelector('text')
      if (textElem) {
        var tspanElem = textElem.querySelector('tspan')
        if (tspanElem) {
          sendEvent(tspanElem.innerHTML + ' Case Study', 'Button', 'Map')
        }
      }

      setModal('map-solution');
    }
  }

  function checkMapView(init) {
    if (window.innerWidth < 1024) {
      hideLocations();

      ignoreLocationChange = true;

      // TODO - Are we supposed to be pulling this from somewhere?
      _map.setVariable('country', 'United States of America');

      var tempName = variables.country.toLowerCase().replace(/ /g, '-');

      var evt = {
        target: {
          id: tempName,
        },
      };
      clicked(evt);

      if (!variables.formRegion) {
        _map.setVariable('country', 'United States of America');
        tempName = variables.country.toLowerCase().replace(/ /g, '-');
        evt = {
          target: {
            id: tempName,
          },
        };
        clicked(evt);
      }

      ignoreLocationChange = false;
    } else if (init === true) {
      showSolutions('warehouse')
    }
  }

  function resetMap() {
    _map.setVariable('formType', null);
    var map = document.getElementsByTagName('svg')[0];
    // map.setAttribute("viewBox", '0 0 1200 800');
    if (map) {
      setViewBox('100 0 1300 850');
      hideSolutions();
      hideLocations();
      _map.setVariable('selectedCountry', null);
      _map.setVariable('selectedSelector', null);
    }

    if (map) {
      map.getElementsByTagName('title')[0].textContent = '';

      var groups = Array.from(document.getElementById('World-Map').children);
      groups.forEach(function (el) {
        if (el.id == 'map') {
          var regions = Array.from(el.children);
          regions.forEach(function (region) {
            region.classList.remove('filled');
            if (region.children) {
              var countries = Array.from(region.children);
              countries.forEach(function (country) {
                country.setAttribute('fill-opacity', '.5');
                // country.setAttribute("filter","none");
                country.classList.remove('filled');
                var countryId = toProperCase(
                  country.id.replace(/-/g, ' ').toUpperCase()
                );
                var noMatch = true;
                // country.setAttribute("fill", "#90ADB1");
                // country.setAttribute("stroke", "#CCCCCC");

                if (data.latinAmerica.includes(countryId)) {
                  country.classList.add('filled');
                  noMatch = false;
                } else if (data.europe.includes(countryId)) {
                  country.classList.add('filled');
                  noMatch = false;
                } else if (data.northAmerica.includes(countryId)) {
                  country.classList.add('filled');
                  noMatch = false;
                } else if (data.ukIreland.includes(countryId)) {
                  country.classList.add('filled');
                  noMatch = false;
                } else if (data.asiaPacific.includes(countryId)) {
                  country.classList.add('filled');
                  noMatch = false;
                } else if (noMatch) {
                  // country.setAttribute("fill", "#E9E9E9");
                  // country.setAttribute("stroke", "#CCCCCC");
                  // country.classList.add("disabled");
                }
              });
            }
          });
        }
      });
    }
  }

  function toProperCase(str) {
    var i, j, lowers, uppers;
    str = str.replace(/([^\W_]+[^\s-]*) */g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });

    // Certain minor words should be left lowercase unless
    // they are the first or last words in the string
    lowers = [
      'A',
      'An',
      'The',
      'And',
      'But',
      'Or',
      'For',
      'Nor',
      'As',
      'At',
      'By',
      'For',
      'From',
      'In',
      'Into',
      'Near',
      'Of',
      'On',
      'Onto',
      'To',
      'With',
    ];
    for (i = 0, j = lowers.length; i < j; i++)
      str = str.replace(
        new RegExp('\\s' + lowers[i] + '\\s', 'g'),
        function (txt) {
          return txt.toLowerCase();
        }
      );

    // Certain words such as initialisms or acronyms should be left uppercase
    uppers = ['Id', 'Tv'];
    for (i = 0, j = uppers.length; i < j; i++)
      str = str.replace(
        new RegExp('\\b' + uppers[i] + '\\b', 'g'),
        uppers[i].toUpperCase()
      );

    return str;
  }

  function showSolutions(slug) {
    scrollToElement(document.getElementById('svg'), 250);
    hideSolutions();

    var shouldSendEvent = variables.selectedSelector !== slug;

    _map.setVariable('selectedSelector', slug);
    data.solutions.forEach(function (solution) {
      if (solution.slug == slug) {
        _map.setVariable('formType', solution.name);
        _map.setVariable('formRegion', 'North America');
        _map.setVariable('solution', solution);

        if (shouldSendEvent) {
          sendEvent(solution.name + ' Solution', 'Button', 'Solution Selector')
        }
      }
    });

    data.industries.forEach(function (industry) {
      if (industry.slug == slug) {
        _map.setVariable('formType', industry.name);
        _map.setVariable('formRegion', 'North America');
        _map.setVariable('solution', industry);

        if (shouldSendEvent) {
          sendEvent(industry.name + ' Industry', 'Button', 'Industry Selector')
        }
      }
    });

    var groups = Array.from(document.getElementById('World-Map').children);
    groups.forEach(function (el) {
      if (el.id == 'solutions') {
        var solutions = Array.from(el.children);
        solutions.forEach(function (solution) {
          if (solution.id == 'solutions_' + slug) {
            solution.setAttribute('display', 'block');
          }
        });
      }
    });
  }

  function hideSolutions() {
    var groups = Array.from(document.getElementById('World-Map').children);
    groups.forEach(function (el) {
      if (el.id == 'solutions') {
        var solutions = Array.from(el.children);
        solutions.forEach(function (solution) {
          solution.setAttribute('display', 'none');
          // solution.setAttribute("cursor", "pointer");
        });
      }
    });
  }

  function showLocations(slug) {
    var groups = Array.from(document.getElementById('World-Map').children);
    groups.forEach(function (el) {
      if (el.id == 'locations') {
        var locations = Array.from(el.children);
        locations.forEach(function (location) {
          if (location.id == 'locations_' + slug) {
            location.setAttribute('display', 'block');
            // location.setAttribute("cursor", "pointer");
            var cities = Array.from(location.children);
            cities.forEach(function (city) {
              var els = Array.from(city.children);
              els.forEach(function (e) {
                if (e.tagName == 'text') {
                  e.setAttribute('font-size', '16');
                }
              });
            });
          }
        });
      }
    });
  }

  function hideLocations() {
    var groups = Array.from(document.getElementById('World-Map').children);
    groups.forEach(function (el) {
      if (el.id == 'locations') {
        var locations = Array.from(el.children);
        locations.forEach(function (location) {
          location.setAttribute('display', 'none');
          // location.setAttribute("cursor", "pointer");
        });
      }
      // if(el.id == 'points' || el.id == 'text') {
      //   let selectors = Array.from(el.children);
      //   selectors.forEach((selector: Element) => {
      //     selector.setAttribute("display", "none");
      //     // selector.setAttribute("cursor", "pointer");
      //   })
      // }
    });
  }

  function scrollToElement($element, offset) { // offset = 70
    // const offset = 68;
    var bodyRect = document.body.getBoundingClientRect().top;
    var elementRect = $element.getBoundingClientRect().top;
    var elementPosition = elementRect - bodyRect;
    var offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }

  function zoomToCountry(str) {
    //var map = document.getElementsByTagName('svg')[0];
    _map.setVariable('regionCountries', variables.countries);
    // map.setAttribute("viewBox", '0 150 500 100');

    var groups = Array.from(document.getElementById('World-Map').children);
    groups.forEach(function (el) {
      if (el.id == 'map') {
        var regions = Array.from(el.children);
        regions.forEach(function (region) {
          region.classList.remove('filled');
          var countries = Array.from(region.children);
          countries.forEach(function (country) {
            var countryId = toProperCase(country.id.replace(/-/g, " ").toUpperCase());
            if ("Russian Federation" != countryId && "Switzerland" != countryId || country.classList.remove("filled"), country.id.toLowerCase() == str.toLowerCase()) {
              // let x = country.getBBox().x,
              // y = country.getBBox().y,
              // width = country.getBBox().width,
              // height = country.getBBox().height;

              region.classList.add('filled');

              var x = region.getBBox().x,
                y = region.getBBox().y,
                width = region.getBBox().width,
                height = region.getBBox().height;

              if (data.latinAmerica.includes(variables.country)) {
                // x = 120, y = 270;
                _map.setVariable('formRegionAcronym', 'LATAM');
                _map.setVariable('formRegion', 'Latin America');
                // this.form.color = 'orange';
                _map.setVariable('regionCountries', data.latinAmerica);
              } else if (data.europe.includes(variables.country)) {
                // x = 340, y = 120;
                _map.setVariable('formRegionAcronym', 'EMEA');
                _map.setVariable('formRegion', 'Europe, Middle East, and Africa');
                // this.form.color = 'blue';
                _map.setVariable('regionCountries', data.europe);
              } else if (data.northAmerica.includes(variables.country)) {
                // x = -20, y = 100;
                _map.setVariable('formRegionAcronym', 'NA');
                _map.setVariable('formRegion', 'North America');
                // this.form.color = 'turquoise';
                _map.setVariable('regionCountries', data.northAmerica);
              } else if (data.ukIreland.includes(variables.country)) {
                // x = 530, y = 250;
                _map.setVariable('formRegionAcronym', 'UKIE');
                _map.setVariable('formRegion', 'United Kingdom and Ireland');
                // this.form.color = 'green';
                _map.setVariable('regionCountries', data.ukIreland);
              } else if (data.asiaPacific.includes(variables.country)) {
                // x = 530, y = 250;
                _map.setVariable('formRegionAcronym', 'APAC');
                _map.setVariable('formRegion', 'Asia Pacific');
                // this.form.color = 'green';
                _map.setVariable('regionCountries', data.asiaPacific);
              } else {
                if (region.id === 'europe') {
                  _map.setVariable('formRegionAcronym', 'EMEA');
                  _map.setVariable('formRegion', 'Europe, Middle East, and Africa');
                } else {
                  _map.setVariable('formRegion', toProperCase(
                    region.id.replace(/-/g, ' ').toUpperCase().trim()
                    ));
                  }
              }

              // this.regions.forEach((region) => {
              //   if(region.name == this.form.region) {
              //     this.currentRegion = region;
              //   }
              // })

              var viewBox = x + ' ' + y + ' ' + width + ' ' + height;
              data.regions.forEach(function (region) {
                if (region.name == variables.formRegion) {
                  viewBox = region.viewBox;
                  _map.setVariable('formStroke', region.stroke);
                  _map.setVariable('formFill', region.fill);
                  addFormStyles(region.stroke, region.fill, region.fillMuted, region.fillPartner);
                }
              });
              setViewBox(viewBox);
            }
          });
        });
      }
    });
  }
  
  function setModal(value) {
    _map.setVariable('modal', value);

    var $links = $('#interactive-map #caseStudyLinks');
    if (value !== null) {
      for (var i in data.caseStudies) {
        if (data.caseStudies[i].id === variables.formId) {
          _map.setVariable('caseStudyTitle', data.caseStudies[i].title);
          _map.setVariable('caseStudyContent', data.caseStudies[i].content);
          $('#interactive-map .interactive-map-modal .thumbnail').attr('src', data.caseStudies[i].image);

          for (var n in data.caseStudies[i].sectors) {
            if (typeof (data.caseStudies[i].sectors[n].color) === 'undefined') {
              data.caseStudies[i].sectors[n].color = 'gray';
            }
          }
          _map.setVariable('caseStudySectors', data.caseStudies[i].sectors);

          $links.empty();
          if (typeof (data.caseStudies[i].links) !== 'undefined') {
            data.caseStudies[i].links.forEach(function (link) {
              $links.append($('<a></a>').attr('href',link.url).attr('class', 'link p-right-4rem').text(link.title));
            });
          }

          break;
        }
      }

      $('body').addClass('modal-open');
    } else {
      setTimeout(function() {
        $links.empty();
        _map.setVariable('caseStudyTitle', null);
        _map.setVariable('caseStudyContent', null);
        _map.setVariable('caseStudySectors', []);
        $('#interactive-map .interactive-map-modal .thumbnail').attr('src', null);
        $('body').removeClass('modal-open');
      }, 500);
    }
  }

  function watchSVGDrag() {
    var svg = document.querySelector('svg');

    if (svg) {
      // If browser supports pointer events
      if (window.PointerEvent) {
        svg.addEventListener('pointerdown', onPointerDown); // Pointer is pressed
        svg.addEventListener('pointerup', onPointerUp); // Releasing the pointer
        svg.addEventListener('pointerleave', onPointerUp); // Pointer gets out of the SVG area
        svg.addEventListener('pointermove', onPointerMove); // Pointer is moving

        svg.addEventListener('touchstart', onPointerDown); // Finger is touching the screen
        svg.addEventListener('touchend', onPointerUp); // Finger is no longer touching the screen
        svg.addEventListener('touchmove', onPointerMove); // Finger is moving

        //var rotation = 0;
        //var gestureStartRotation = 0;
        //var gestureStartScale = 0;
        var scale = 1;
        var posX = 0;
        var posY = 0;
        //var startX;
        //var startY;

        var prevScale;

        var timeout;
        // var doneScrolling = false;
        var zoomed = false;

        svg.addEventListener(
          'wheel',
          function (e) {
            // e.preventDefault();

            clearTimeout(timeout);

            if (e.ctrlKey) {
              prevScale = scale;
              scale -= e.deltaY * 0.01;
            } else {
              posX -= e.deltaX * 2;
              posY -= e.deltaY * 2;
            }

            // render();
            if (scale != 1) {
              e.preventDefault();
            }

            if (prevScale > scale && !zoomed) {
              zoomViewBox('minus');
              zoomed = true;
            }
            if (prevScale < scale && !zoomed) {
              zoomViewBox('plus');
              zoomed = true;
            }

            timeout = setTimeout(function() {
              scale = 1;
              // doneScrolling = true;
              zoomed = false;
            }, 500);
          },
          { passive: true }
        );
      } else {
        // Add all mouse events listeners fallback
        svg.addEventListener('mousedown', onPointerDown); // Pressing the mouse
        svg.addEventListener('mouseup', onPointerUp); // Releasing the mouse
        svg.addEventListener('mouseleave', onPointerUp); // Mouse gets out of the SVG area
        svg.addEventListener('mousemove', onPointerMove); // Mouse is moving

        // Add all touch events listeners fallback
        svg.addEventListener('touchstart', onPointerDown); // Finger is touching the screen
        svg.addEventListener('touchend', onPointerUp); // Finger is no longer touching the screen
        svg.addEventListener('touchmove', onPointerMove); // Finger is moving
      }
    }

    // Create an SVG point that contains x & y values
    var point;
    if (svg) {
      point = svg.createSVGPoint();
    }
    // This function returns an object with X & Y values from the pointer event
    function getPointFromEvent(event) {
      // If even is triggered by a touch event, we get the position of the first finger
      if (event.touches) {
        point.x = event.touches[0].clientX;
        point.y = event.touches[0].clientY;
      } else {
        point.x = event.clientX;
        point.y = event.clientY;
      }

      // We get the current transformation matrix of the SVG and we inverse it
      var invertedSVGMatrix = svg.getScreenCTM().inverse();
      return point.matrixTransform(invertedSVGMatrix);
    }

    // This variable will be used later for move events to check if pointer is down or not
    var isPointerDown = false;

    // This variable will contain the original coordinates when the user start pressing the mouse or touching the screen
    var pointerOrigin;

    var dist1 = 0;
    var zoomDir = null;

    // Function called by the event listeners when user start pressing/touching
    function onPointerDown(event) {
      isPointerDown = true; // We set the pointer as down

      // We get the pointer position on click/touchdown so we can get the value once the user starts to drag
      pointerOrigin = getPointFromEvent(event);

      if (event.touches && event.touches.length == 2) {
        //check if two fingers touched screen
        dist1 = Math.hypot(
          //get rough estimate of distance between two fingers
          event.touches[0].pageX - event.touches[1].pageX,
          event.touches[0].pageY - event.touches[1].pageY
        );
      }
    }

    // We save the original values from the viewBox
    var viewBox;
    if (svg) {
      viewBox = svg.viewBox.baseVal;
    }

    // Function called by the event listeners when user start moving/dragging
    function onPointerMove(event) {
      // Only run this function if the pointer is down
      if (!isPointerDown) {
        return;
      }
      // This prevent user to do a selection on the page
      event.preventDefault();

      // Get the pointer position as an SVG Point
      var pointerPosition = getPointFromEvent(event);

      if (event.touches && event.touches.length == 2) {
        // Check if the two target touches are the same ones that started
        var dist2 = Math.hypot(
          //get rough estimate of new distance between fingers
          event.touches[0].pageX - event.touches[1].pageX,
          event.touches[0].pageY - event.touches[1].pageY
        );
        //alert(dist);
        if (dist1 > dist2) {
          //if fingers are closer now than when they first touched screen, they are pinching
          zoomDir = 'minus';
          event.preventDefault();
        }
        if (dist1 < dist2) {
          //if fingers are further apart than when they first touched the screen, they are making the zoomin gesture
          zoomDir = 'plus';
          event.preventDefault();
        }
      } else if (event.pointerType != 'touch') {
        // Update the viewBox variable with the distance from origin and current position
        // We don't need to take care of a ratio because this is handled in the getPointFromEvent function
        viewBox.x -= pointerPosition.x - pointerOrigin.x;
        viewBox.y -= pointerPosition.y - pointerOrigin.y;
        if (viewBox.x < -75) {
          viewBox.x = -75;
        }
        if (viewBox.x > 1000) {
          viewBox.x = 1000;
        }
        if (viewBox.y < 0) {
          viewBox.y = 0;
        }
        if (viewBox.y > 450) {
          viewBox.y = 450;
        }
        newViewBox =
          viewBox.x +
          ' ' +
          viewBox.y +
          ' ' +
          viewBox.width +
          ' ' +
          viewBox.height;
        svg.setAttribute('viewBox', newViewBox);
      }
    }

    function onPointerUp() {
      // The pointer is no longer considered as down
      isPointerDown = false;

      if (zoomDir) {
        zoomViewBox(zoomDir);
        zoomDir = null;
      }
    }
  }

  var newViewBox = '100 0 1300 850';
  function setViewBox(viewBox) {
    var map = document.getElementsByTagName('svg')[0];
    if (map) {
      var svgns = 'http://www.w3.org/2000/svg';
      var shape = document.createElementNS(svgns, 'animate');
      shape.setAttributeNS(null, 'attributeName', 'viewBox');
      shape.setAttributeNS(null, 'to', viewBox);
      shape.setAttributeNS(null, 'from', newViewBox);
      shape.setAttributeNS(null, 'dur', '1s');
      shape.setAttributeNS(null, 'fill', 'freeze');
      map.setCurrentTime(0);
      map.appendChild(shape);

      newViewBox = viewBox;

      setTimeout(function() {
        map.setAttribute('viewBox', newViewBox);
        var animations = Array.from(map.getElementsByTagName('animate'));
        animations.forEach(function (ele) {
          map.removeChild(ele);
        });
      }, 1500);
    }
  }

  function zoomViewBox(dir) {
    var coords = newViewBox.split(' ');
    var viewBox = '';
    var minX = parseInt(coords[0]);
    var minY = parseInt(coords[1]);
    var x = parseInt(coords[2]);
    var y = parseInt(coords[3]);

    if (dir == 'minus') {
      minX = parseInt(coords[0]) - (parseInt(coords[2]) * 0.35) / 2;
      minY = parseInt(coords[1]) - (parseInt(coords[3]) * 0.35) / 2;
      x = parseInt(coords[2]) + parseInt(coords[2]) * 0.35;
      y = parseInt(coords[3]) + parseInt(coords[3]) * 0.35;
    }
    if (dir == 'plus') {
      minX = parseInt(coords[0]) + (parseInt(coords[2]) * 0.35) / 2;
      minY = parseInt(coords[1]) + (parseInt(coords[3]) * 0.35) / 2;
      x = parseInt(coords[2]) - parseInt(coords[2]) * 0.35;
      y = parseInt(coords[3]) - parseInt(coords[3]) * 0.35;
    }
    viewBox = minX + ' ' + minY + ' ' + x + ' ' + y;

    if (x > 100 && x < 1000 && y > 100 && y < 1000) {
      setViewBox(viewBox);
    }
  }

  _map.onResize = function(width, height) {
    if (variables.loadedMap === true) {
      checkMapView();
    }
  };

  return _map;
}(_map || {}));